<template>
  <div>
    <NavTools />
    <div class="container" style="width: 400px" v-if="expiredMessage">
      <center>
        <h3 style="color: #e96724;">{{ expiredMessage }}</h3>
      </center>
    </div>
    <div style="background-color: #fff" id="player" v-cloak v-if="!expiredMessage">
      <Alert />
      <Spinner />
      <div
        style="position: fixed; top: 69px; left: 0"
        v-if="user_status == 'super'"
      >
        <div style="margin: 15px">
          <a
            class="btn btn-default"
            style="
              background-color: #e96724;
              color: #ffffff;
              text-shadow: none;
              border: none;
            "
            v-on:click="confirmAllSends()"
            role="button"
            ><span
              class="glyphicon glyphicon-send"
              style="padding-right: 5px"
            ></span
            >Confirm all sends for user</a
          >
        </div>
        <div style="margin: 15px">
          <a
            class="btn btn-primary"
            style="background-color: #79a9ad; border: none"
            v-bind:class="{ disabled: send_status == 'SENT' }"
            v-on:click="confirmThisSend()"
            role="button"
            >{{ send_status == 'SENT' ? 'Already sent' : 'Confirm this send only' }}</a
          >
        </div>
        <div style="margin: 15px">
          <a
            v-bind:href="user_link"
            target="_blank"
            class="btn btn-primary"
            style="background-color: #79a9ad; border: none"
            role="button"
            ><span
              class="glyphicon glyphicon-wrench"
              style="padding-right: 5px"
            ></span
            >Edit in IIAB</a
          >
        </div>
        <div style="margin: 15px">
          <a class="btn btn-default" v-on:click="rotateVideo('left')" role="button"
            >Rotate Left</a
          >
          <a class="btn btn-default" v-on:click="rotateVideo('right')" role="button"
            >Rotate Right</a
          >
        </div>
        <div style="margin: 15px">
          <a class="btn btn-default" v-on:click="regenerateFrame()" role="button"
            >Regenerate Frame</a
          >
        </div>
        <div style="margin: 15px">
          <a class="btn btn-default" v-on:click="skipAndClose()" role="button"
            >Skip</a
          >
        </div>
      </div>
      <div class="container" v-show="!loginRequired">
        <div v-show="videometa.ivType == 'otis' || videometa.ivType == 'epic'">
          <div class="ep-recording-header text-center">
            <h1>
              {{
                videometa.ivType == "otis" && activeGlimpseTab === 'recommendation'
                  ? "Recommender Video"
                  : videometa.ivType == "otis"
                  ? "Glimpse Video"
                  : "EPIC Video"
              }}
            </h1>
          </div>
          <div class="ep-recording-body">
            <!-- Glimpse Tab Navigation -->
            <div v-if="videometa.ivType == 'otis'" class="glimpse-tabs-container">
              <ul class="glimpse-tabs">
                <li 
                  :class="{ 'active': activeGlimpseTab === 'overview' }"
                  @click="setActiveGlimpseTab('overview')"
                >
                  Glimpse Video
                </li>
                <li 
                  v-if="echoData && echoData.qa_complete && echoData.video_url && videometa.ivType == 'otis'"
                  :class="{ 'active': activeGlimpseTab === 'recommendation' }"
                  @click="setActiveGlimpseTab('recommendation')"
                >
                  <img :src="env.staticAddr + '/ivgcs/img/echo-text-logo.svg'" alt="ECHO™" height="18px">
                </li>
              </ul>
            </div>

            <!-- Glimpse Overview Tab Content -->
            <div v-show="videometa.ivType == 'otis' && activeGlimpseTab === 'overview'">
              <div
                class="row"
                style="margin-top: -15px"
                v-show="videometa.ivType == 'otis'"
              >
              <div class="col-md-12">
                <span
                  class="glyphicon glyphicon-question-sign pull-right"
                  style="color: #e96724; font-size: 230%; margin-left: 12px"
                  v-on:click="openModal('ep-explain')"
                ></span>
                <div class="orange-font" style="text-align: right">
                  WHAT IS A GLIMPSE?
                </div>
                <div style="text-align: right">
                  Is it different from the InitialView Interview?
                  <span class="orange-font">//</span> Yes it is!
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-10 col-lg-offset-1 text-center">
                <h1 data-cy="glimpseName">{{ videometa.user }}</h1>
                <div v-if="videometa.ivType == 'otis'">
                  <div
                    class="row text-center"
                    v-if="applicationIds.length == 0"
                  >
                    <div class="col-md-6" v-if="current_school!=''">
                      <h5>Current School</h5>
                      <h4 data-cy="glimpseCurrentSchool" class="overflow-word-break">
                        {{ current_school }}
                      </h4>
                    </div>
                    <div class="col-md-6">
                      <h5>Application Email</h5>
                      <h4 v-if="appEmail.length < 36" data-cy="glimpseEmail">
                        {{ appEmail }}
                      </h4>
                      <h4 v-else class="overflow-word-break" data-cy="glimpseEmail">
                        {{ appEmail.split("@")[0] }}
                        <br/>
                        {{ "@" + appEmail.split("@")[1] }}
                      </h4>
                    </div>
                  </div>
                  <div
                    class="row text-center"
                    v-if="applicationIds.length == 1"
                  >
                    <div class="col-md-4" v-if="current_school!=''">
                      <h5>Current School</h5>
                      <h4 data-cy="glimpseCurrentSchool" class="overflow-word-break">
                        {{ current_school }}
                      </h4>
                    </div>
                    <div class="col-md-4">
                      <h5>Application Email</h5>
                      <h4 v-if="appEmail.length < 24" data-cy="glimpseEmail">
                        {{ appEmail }}
                      </h4>
                      <h4 v-else class="overflow-word-break" data-cy="glimpseEmail">
                        {{ appEmail.split("@")[0] }}
                        <br/>
                        {{ "@" + appEmail.split("@")[1] }}
                      </h4>
                    </div>
                    <div class="col-md-4">
                      <h5>{{ applicationIds[0].name }}</h5>
                      <h4>{{ applicationIds[0].value }}</h4>
                    </div>
                  </div>
                  <div
                    class="row text-center"
                    v-if="applicationIds.length == 2"
                  >
                    <div class="col-md-3" v-if="current_school!=''">
                      <h5>Current School</h5>
                      <h4 data-cy="glimpseCurrentSchool" class="overflow-word-break">
                        {{ current_school }}
                      </h4>
                    </div>
                    <div class="col-md-4">
                      <h5>Application Email</h5>
                      <h4 v-if="appEmail.length < 24" data-cy="glimpseEmail">
                        {{ appEmail }}
                      </h4>
                      <h4 v-else class="overflow-word-break" data-cy="glimpseEmail">
                        {{ appEmail.split("@")[0] }}
                        <br/>
                        {{ "@" + appEmail.split("@")[1] }}
                      </h4>
                    </div>
                    <div class="col-md-3">
                      <h5>{{ applicationIds[0].name }}</h5>
                      <h4>{{ applicationIds[0].value }}</h4>
                    </div>
                    <div class="col-md-2">
                      <h5>{{ applicationIds[1].name }}</h5>
                      <h4>{{ applicationIds[1].value }}</h4>
                    </div>
                  </div>
                  <div
                    class="row text-center"
                    v-if="applicationIds.length > 2"
                  >
                    <div class="col-md-3" v-if="current_school!=''">
                      <h5>Current School</h5>
                      <h4 data-cy="glimpseCurrentSchool" class="overflow-word-break">
                        {{ current_school }}
                      </h4>
                    </div>
                    <div class="col-md-3">
                      <h5>Application Email</h5>
                      <h4 v-if="appEmail.length < 24" data-cy="glimpseEmail">
                        {{ appEmail }}
                      </h4>
                      <h4 v-else class="overflow-word-break" data-cy="glimpseEmail">
                        {{ appEmail.split("@")[0] }}
                        <br/>
                        {{ "@" + appEmail.split("@")[1] }}
                      </h4>
                    </div>
                    <div v-for="app in applicationIds">
                      <div class="col-md-2">
                        <h5>{{ app.name }}</h5>
                        <h4>{{ app.value }}</h4>
                      </div>
                  </div>
                  </div>
                  <div class="star-text" data-cy="glimpseStar" v-show="videometa.star">
                    <h4>
                      <img
                        style="
                          margin-left: 25px;
                          width: 60px;
                          margin-right: 15px;
                        "
                        :src="staticaddr + '/s/img/_shared/OrangeStar.png'"
                      />
                      <span
                        >This applicant has given one of two stars to
                        {{ videometa.org }}!</span
                      >
                    </h4>
                  </div>
                  <div class="rose_text" data-cy="glimpseRose" v-show="videometa.rose">
                    <h4>
                      <img
                        style="
                          margin-left: 25px;
                          width: 60px;
                          margin-right: 15px;
                        "
                        :src="staticaddr + '/ivgcs/img/single-yellow-rose.png'"
                      />
                      <span
                        >This applicant has given their Single Yellow Rose to
                        {{ videometa.org }}!</span
                      >
                    </h4>
                  </div>
                </div>
              </div>

              <div class="col-md-12 text-center">
                <div v-show="cbo_name && !cbo_profile_img">
                  <h4>
                    <img
                      style="margin-left: 25px; width: 60px"
                      :src="staticaddr + '/ivgcs/img/cbo-icon.svg'"
                    />
                    <span style="font-weight: bold">{{ cbo_name }}</span>
                  </h4>
                </div>
              </div>

              <div class="col-md-12 text-center">
                <div
                  v-show="cbo_profile_img"
                  style="cursor: pointer"
                  v-on:click="openModal('cbo-profile')"
                >
                  <h4>
                    <img
                      style="margin-left: 25px; width: 60px"
                      :src="staticaddr + '/ivgcs/img/cbo-icon.svg'"
                    />
                    <span
                      ><span style="font-weight: bold">{{ cbo_name }}</span
                      >: View College Access CBO Profile linked to this
                      student</span
                    >
                  </h4>
                </div>
              </div>

              <div
                v-if="
                  videometa.ivType == 'epic' && videometa.video_qad == false
                "
                class="col-md-12 col-lg-10 col-lg-offset-1 interview-video"
                data-cy="glimpseNoVideo"
              >
                <div
                  style="padding: 80px; background: white"
                  class="text-center"
                >
                  This student has yet to submit a video.
                </div>
              </div>
              <div
                v-else
                class="col-md-12 col-lg-10 col-lg-offset-1 interview-video"
                data-cy="glimpseVideo"
              >
                <IVPlayer customid="otis"></IVPlayer>
              </div>

              <div
                class="col-md-12 text-center"
                data-cy="glimpseBlockVideo"
                v-if="videometa.ivee_block_video"
              >
                &#42;Student chose to record the Glimpse with just audio
              </div>

              <div
                v-show="videometa.ivType == 'otis'"
                class="player-content-box col-xs-offset-2 col-xs-8"
                style="border-radius: 10px; margin-top: 15px"
              >
                <div class="row">
                  <div
                    class="col-xs-offset-1 col-xs-10 text-center"
                    style="margin-bottom: 15px"
                    v-show="ivType != 'parent'"
                  >
                    <button
                      v-if="inSlateIframe()"
                      class="btn btn-block btn-player-content"
                      data-cy="glimpseOpenVideoReply"
                    >
                      <a v-bind:href="getSlateIframeHref()" target="_blank">
                        <div style="display: flex; align-items: center">
                          <img
                            src="../assets/send_video_reply.svg"
                            width="32px"
                          />
                          <div v-if="!responses" style="width: 100%" class="text-center">
                            SEND A VIDEO REPLY
                          </div>
                          <div v-if="responses" style="width: 100%" class="text-center">
                            YOU SENT A VIDEO REPLY
                          </div>
                        </div>
                      </a>
                    </button>
                    <button
                      v-if="!inSlateIframe()"
                      class="btn btn-block btn-player-content"
                      v-on:click="openModal('videoReplyModal')"
                      data-cy="glimpseOpenVideoReply"
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          src="../assets/send_video_reply.svg"
                          width="32px"
                        />
                        <div v-if="!responses" style="width: 100%" class="text-center">
                          SEND A VIDEO REPLY
                        </div>
                        <div v-if="responses" style="width: 100%" class="text-center">
                          YOU SENT A VIDEO REPLY
                        </div>
                      </div>
                    </button>
                  </div>
                  <div
                    class="col-xs-offset-1 col-xs-10 text-center"
                    style="margin-bottom: 15px"
                    v-show="ivType != 'parent'"
                  >
                    <b v-if="iverThanks"
                      >This student responded to your video reply with
                      "Thanks"!</b
                    >
                    <b v-if="!responses">Show this student some love!</b>
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-if="videometa.ivType == 'epic'">
                <div class="row" style="margin-top: 30px; margin-bottom: 5px">
                  <div class="col-md-6 text-right"><b>High School</b></div>
                  <div class="col-md-6">{{ current_school }}</div>
                </div>
                <div class="row" style="margin-top: 5px; margin-bottom: 5px">
                  <div class="col-md-6 text-right"><b>High School City</b></div>
                  <div class="col-md-6">{{ hsCity }}, {{ hsState }}</div>
                </div>
                <div class="row" style="margin-top: 5px; margin-bottom: 5px">
                  <div class="col-md-6 text-right">
                    <b>Self-reported Grades</b>
                  </div>
                  <div class="col-md-6">
                    {{ grades in gradeLabels ? gradeLabels[grades].label : "" }}
                  </div>
                </div>
                <div class="row" style="margin-top: 5px; margin-bottom: 5px">
                  <div class="col-md-6 text-right">
                    <b>Academic Interests</b>
                  </div>
                  <div class="col-md-6">
                    {{
                      (interests ? interests : [])
                        .filter((i) => i in academicInterests)
                        .map((i) => academicInterests[i].label)
                        .join(", ")
                    }}
                  </div>
                </div>
                <div class="row" style="margin-top: 5px; margin-bottom: 5px">
                  <div class="col-md-6 text-right">
                    <b>Preferred Campus Size</b>
                  </div>
                  <div class="col-md-6">
                    {{
                      (sizes ? sizes : [])
                        .filter((i) => i in collegeSize)
                        .map((i) => collegeSize[i].label)
                        .join(", ")
                    }}
                  </div>
                </div>
                <div class="row" style="margin-top: 5px; margin-bottom: 5px">
                  <div class="col-md-6 text-right">
                    <b>Preferred Geography</b>
                  </div>
                  <div class="col-md-6">
                    {{
                      (geographies ? geographies : [])
                        .filter((i) => i in geographicPreference)
                        .map((i) => geographicPreference[i].label)
                        .join(", ")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <h4>
                  <a :href="ivSummary" target="_blank">
                    Open Applicant Info PDF in a new tab
                  </a>
                </h4>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="cbo-profile"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            style="z-index: 1000001"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content" style="border-radius: 0px">
                <div class="modal-body" style="overflow-y: scroll">
                  <div class="row">
                    <div class="col-md-12">
                      <a v-bind:href="cbo_profile_pdf" target="_blank"
                        >Click to download CBO Profile</a
                      >
                      <img
                        v-bind:src="cbo_profile_img"
                        class="img-responsive"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="ep-explain"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            style="z-index: 1000001"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content" style="border-radius: 0px">
                <div class="modal-body" style="overflow-y: scroll">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 style="font-style: italic; font-weight: bold">
                        This applicant has sent you an InitialView
                        <span class="orange-font">Glimpse</span>:
                      </h4>
                    </div>
                  </div>
                  <div
                    class="row"
                    style="
                      background-color: #e96724;
                      margin: 10px;
                      margin: 20px 20px 25px 20px;
                      padding: 20px 5px 25px 5px;
                    "
                  >
                    <div class="col-md-2">
                      <img
                        style="width: 60px"
                        :src="staticaddr + '/ivgcs/img/icon-video-camera.svg'"
                        class="pull-right"
                      />
                    </div>
                    <div class="col-md-9">
                      <div style="color: white">
                        90-SECOND VIDEO: This is a quick “glimpse” that
                        the applicant self-records as a way to tell their story
                        apart from their traditional application.
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                      <table class="table table-striped">
                        <tr>
                          <th
                            class="orange-font"
                            style="font-size: 140%; font-style: italic"
                          >
                            Side-by-Side Comparison
                          </th>
                          <th class="text-center">INITIALVIEW INTERVIEW</th>
                          <th class="text-center">GLIMPSE</th>
                        </tr>
                        <tr>
                          <td>
                            Unrehearsed interview with professional interviewer
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-remove ep-compare x"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Transparent view of English ability for
                            international applicants
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-remove ep-compare x"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Provides U.S. applicants with a platform to tell
                            their story and signal school preference
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-remove ep-compare x"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>Unlimited sends to colleges and universities</td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            2 Virtual Stars to demonstrate interest to 2 top
                            choice schools during Regular Decision
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>Writing Sample included</td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-remove ep-compare x"
                            ></span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Half of all fees donated to support CBOs focused on
                            college access
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-remove ep-compare x"
                            ></span>
                          </td>
                          <td>
                            <span
                              class="glyphicon glyphicon-ok ep-compare check"
                            ></span>
                          </td>
                        </tr>
                        <tr style="background-color: white">
                          <td colspan="3">
                            <span class="orange-font"
                              >An applicant may send either an InitialView
                              Interview or a Glimpse to a school, but
                              not both.</span
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <button
                        class="btn btn-lg btn-orange"
                        v-on:click="closeModal('ep-explain')"
                      >
                        OK, I got it
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-md-12 text-center"
                      style="font-style: italic"
                    >
                      <div>
                        More information on Glimpses is available at:
                      </div>
                      <div>
                        <a
                          :href="serveraddr + '/glimpse'"
                          target="_blank"
                          style="text-decoration: underline"
                          >initialview.com/glimpse</a
                        >
                      </div>
                      <div>
                        <a
                          :href="serveraddr + '/glimpse/faqs'"
                          target="_blank"
                          style="text-decoration: underline"
                          >initialview.com/glimpse/faqs</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            
            <!-- Glimpse Recommendation Tab Content -->
            <div v-show="videometa.ivType == 'otis' && activeGlimpseTab === 'recommendation' && echoData">
              <div class="row" style="margin-top: 20px;">
                <div class="col-md-6">
                  <div v-if="echoData && echoData.video_url" class="video-container">
                    <video 
                      controls 
                      :src="echoData.video_url"
                      style="width: 100%; max-width: 500px; border: 2px solid #e96724; border-radius: 8px;"
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div v-else class="text-center text-muted" style="margin-top: 50px; padding: 40px; background: #f9f9f9; border: 2px solid #e96724; border-radius: 8px;">
                    <div style="font-size: 18px; margin-bottom: 10px;">📹</div>
                    <div>Video recommendation is being processed</div>
                    <div style="font-size: 14px; color: #666; margin-top: 10px;">
                      The video will appear here once processing is complete
                    </div>
                  </div>
                </div>
                <div class="col-md-6" v-if="echoData">
                  <h3 style="color: #e96724; margin-bottom: 20px;">Recommender Details</h3>
                  <div class="recommendation-details" style="background: white; padding: 20px; border: 2px solid #e96724; border-radius: 8px;">
                    <div class="detail-item" style="margin-bottom: 15px;">
                      <strong style="color: #e96724;">Recommender Name:</strong>
                      <div>{{ echoData.rec_name }}</div>
                    </div>
                    <div class="detail-item" style="margin-bottom: 15px;">
                      <strong style="color: #e96724;">Role: </strong>
                      <div class="text-capitalize">{{ echoData.rec_type }}</div>
                    </div>
                    <div class="detail-item" style="margin-bottom: 15px;" v-if="echoData.subject_taught">
                      <strong style="color: #e96724;">Subject Taught:</strong>
                      <div>{{ echoData.subject_taught }}</div>
                    </div>
                    <div class="detail-item" style="margin-bottom: 15px;" v-if="echoData.rec_email">
                      <strong style="color: #e96724;">Email:</strong>
                      <div>{{ echoData.rec_email }}</div>
                    </div>
                    <div class="detail-item" v-if="echoData.ferpa_waived !== undefined">
                      <strong style="color: #e96724;">FERPA Waiver:</strong>
                      <div>{{ echoData.ferpa_waived ? 'Waived' : 'Not Waived' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-show="
            videometa.ivType &&
            videometa.ivType != 'otis' &&
            videometa.ivType != 'epic'
          "
        >
          <div class="col-md-12">
            <div
              class="row tab-header-row"
              v-show="
                ivWritingEval != '' ||
                ivWriting != '' ||
                ivSummary != '' ||
                ivResume != ''
              "
              style="margin-bottom: 0px; display: flex; flex-wrap: nowrap;"
            >
              <a
                href="#"
                v-on:click.prevent="showTab('hsprofile')"
                v-show="
                  videometa.org == 'University of Illinois at Urbana-Champaign'
                "
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'hsprofile',
                  }"
                >
                  <span class="glyphicon glyphicon-education"></span> High
                  School Profile
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('video')"
                v-show="videometa.ivType != 'writing'"
              >
                <div
                  class="tab-header"
                  v-bind:class="{ 'tab-header-active': current_tab == 'video' }"
                >
                  <span class="glyphicon glyphicon-film"></span> Interview Video
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('writing-eval')"
                v-show="ivWritingEval != ''"
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'writing-eval',
                  }"
                >
                  <span class="glyphicon glyphicon-pencil"></span> Writing
                  Sample
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('writing')"
                v-show="ivWriting != ''"
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'writing',
                  }"
                >
                  <span class="glyphicon glyphicon-pencil"></span> Writing
                  Sample
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('resume')"
                v-show="ivResume"
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'resume',
                  }"
                >
                  <span class="glyphicon glyphicon glyphicon-list-alt"></span>
                  Resume
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('summary')"
                v-show="ivSummary != '' && videometa.ivType != 'writing'"
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'summary',
                  }"
                >
                  <span class="glyphicon glyphicon-user"></span> Applicant Info
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('hsprofile')"
                v-show="
                  videometa.org !=
                    'University of Illinois at Urbana-Champaign' &&
                  ivHSProfile != ''
                "
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'hsprofile',
                  }"
                >
                  <span class="glyphicon glyphicon-education"></span> High
                  School Profile
                </div>
              </a>
              <a
                href="#"
                v-on:click.prevent="showTab('echo')"
                v-show="echoData && echoData.qa_complete"
              >
                <div
                  class="tab-header"
                  v-bind:class="{
                    'tab-header-active': current_tab == 'echo',
                  }"
                >
                  <span class="glyphicon glyphicon-bookmark"></span>
                  <img
                    :src="env.staticAddr + '/ivgcs/img/echo-text-logo.svg'"
                    alt="ECHO™"
                    height="14px"
                    style="margin-bottom: 5px; margin-left: 3px;"
                  >
                </div>
              </a>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row"
              v-show="current_tab == 'writing-eval'"
              style="padding: 0"
            >
              <div
                class="
                  col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2
                "
              >
                <h1 v-show="videometa.ivType == 'writing'">
                  {{ videometa.user }}
                </h1>
                <h4 style="margin-top: 40px; margin-bottom: 30px">
                  {{ writingPrompt }}
                </h4>
                <div
                  class="well"
                  style="
                    font-size: 120%;
                    background-image: unset;
                    background-color: white;
                    min-height: 400px;
                    white-space: pre-wrap;
                  "
                >
                  {{ ivWritingEval }}
                </div>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row"
              v-show="current_tab == 'hsprofile'"
              style="padding: 0"
            >
              <div class="col-md-12">
                <HSProfile
                  v-show="hsprofile.hs_name"
                  :hsprofile="hsprofile"
                  :ivee-data="videometa"
                  :cur-length="hsprofile.curricula.length"
                  @load-other-profile="fetchHsProfile"
                />
                <div
                  v-show="!hsprofile.hs_name"
                  class="text-center"
                  style="padding: 150px 0"
                >
                  <h4>No Profile Available For This School</h4>
                </div>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row tab-area-row-pdf"
              v-show="current_tab == 'writing'"
            >
              <h1 v-show="videometa.ivType == 'writing'">
                {{ videometa.user }}
              </h1>
              <div class="col-md-12">
                <object
                  v-bind:data="ivWriting"
                  width="100%"
                  height="100%"
                  type="application/pdf"
                >
                  <div class="text-center">
                    <h4>
                      <a :href="ivWriting" target="_blank"
                        >Open PDF in a new tab</a
                      >
                    </h4>
                  </div>
                </object>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row tab-area-row-pdf"
              v-show="current_tab == 'resume'"
            >
              <div class="col-md-12">
                <object
                  v-bind:data="ivResume"
                  width="100%"
                  height="100%"
                  type="application/pdf"
                >
                  <div class="text-center">
                    <h4>
                      <a :href="ivResume" target="_blank"
                        >Open PDF in a new tab</a
                      >
                    </h4>
                  </div>
                </object>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row tab-area-row-pdf"
              v-show="current_tab == 'summary'"
            >
              <div class="col-md-12">
                <object
                  v-bind:data="ivSummary"
                  width="100%"
                  height="100%"
                  type="application/pdf"
                >
                  <div class="text-center">
                    <h4>
                      <a :href="ivSummary" target="_blank"
                        >Open PDF in a new tab</a
                      >
                    </h4>
                  </div>
                </object>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row"
              v-show="current_tab == 'video'"
            >
              <div class="col-md-6">
                <h1 id="interviewee_name" data-cy="interviewName">{{ videometa.user }}</h1>
              </div>
              <div class="col-md-6">
                <h4 data-cy="interviewDate">Interview Date: {{ videometa.date }}</h4>
              </div>
              <div class="col-md-12">
                <div class="star-text" data-cy="interviewStar" v-show="videometa.star">
                  <div class="row" style="margin: 0">
                    <div class="col-xs-1">
                      <img
                        style="width: 60px"
                        :src="staticaddr + '/s/img/_shared/OrangeStar.png'"
                      />
                    </div>
                    <div class="col-xs-11">
                      <h4 style="margin-top: 20px">
                        This student has given one of two stars to
                        {{ videometa.org }}!
                        <span v-if="videometa.ivType == 'college'"
                          >(<a
                            href="#"
                            data-toggle="modal"
                            data-target="#starreport"
                            >Click here for your year-to-date star report</a
                          >)</span
                        >
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="rose_text" data-cy="interviewRose" v-show="videometa.rose">
                  <div class="row" style="margin: 0">
                    <div class="col-xs-1">
                      <img
                        style="width: 60px"
                        :src="staticaddr + '/ivgcs/img/single-yellow-rose.png'"
                      />
                    </div>
                    <div class="col-xs-11">
                      <h4 style="margin-top: 20px">
                        This student has given their Single Yellow Rose to
                        {{ videometa.org }}!
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12" v-show="videometa.ivType != 'graduate' && videometa.ivType != 'grad-with-sample'">
                <div class="star-text" data-cy="interviewRecruitment" v-show="videometa.recruited">
                  <div class="row" style="margin: 0">
                    <div class="col-xs-1">
                      <img
                        style="width: 60px"
                        :src="
                          staticaddr + '/s/img/_shared/icon-iv-referred.png'
                        "
                      />
                    </div>
                    <div class="col-xs-12">
                      <h4>
                        This student sent their interview to
                        {{ videometa.org }} after sending their interview to a
                        peer school, as determined by a proprietary “suggestion”
                        algorithm. Learn more about how to take advantage of
                        this process
                        <a
                          v-bind:href="env.ameliaAddr + '/re-info/' + urlVparam"
                          target="_blank"
                          >here</a
                        >.
                      </h4>
                    </div>
                  </div>
                </div>
              </div> 
              <div class="col-md-12">
                <div class="star-text" v-show="videometa.schoolName">
                  <div class="row" style="margin: 0">
                    <div class="col-xs-1">
                      <img
                        style="width: 60px"
                        :src="
                          staticaddr + '/s/img/_shared/icon-iv-curriculum.png'
                        "
                      />
                    </div>
                    <div class="col-xs-11">
                      <h4 data-cy="interviewSchoolAndCurriculum" style="margin-top: 20px">
                        {{ videometa.schoolName
                        }}<span v-show="videometa.curriculum"
                          >, {{ videometa.curriculum }}</span
                        >
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="videometa.ivType == 'gaokao'"
                class="col-sm-12 well"
                data-cy="interviewGaokaoScores"
                style="font-size: 120%"
              >
                <div class="row" style="margin-top: 0">
                  <div class="col-sm-12">
                    Overall Gaokao Score: {{ gaokao_data.gaokao_overall }}
                  </div>
                </div>
                <div class="row" style="margin-bottom: 0">
                  <div class="col-sm-2">
                    Math<br />{{ gaokao_data.gaokao_math }}
                  </div>
                  <div class="col-sm-2">
                    Chinese<br />{{ gaokao_data.gaokao_chinese }}
                  </div>
                  <div class="col-sm-2">
                    English<br />{{ gaokao_data.gaokao_english }}
                  </div>
                  <div class="col-sm-2">
                    {{ gaokao_data.gaokao_subj_4 }}<br />{{
                      gaokao_data.gaokao_subsc_4
                    }}
                  </div>
                  <div class="col-sm-2">
                    {{ gaokao_data.gaokao_subj_5 }}<br />{{
                      gaokao_data.gaokao_subsc_5
                    }}
                  </div>
                  <div class="col-sm-2">
                    {{ gaokao_data.gaokao_subj_6 }}<br />{{
                      gaokao_data.gaokao_subsc_6
                    }}
                  </div>
                </div>
              </div>

              <div
                v-if="videometa.ivType == 'math'"
                class="col-sm-12"
                style="font-size: 120%"
              >
                <div class="row" style="margin-top: 0">
                  <div class="col-sm-12 text-center">
                    <a v-bind:href="videometa.aux_url" target="_blank" data-cy="interviewMathProblem">
                      View the problem the student was asked to solve and the student's work
                    </a>
                  </div>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-6 col-sm-12 col-xs-12 interview-video"
                data-cy="interviewVideo"
              >
                <IVPlayer></IVPlayer>

                <div id="rate-student" class="row" style="margin-top: 20px">
                  <div
                    class="player-content-box col-xs-offset-2 col-xs-8"
                    data-cy="interviewAISummary"
                    style="border-radius: 10px; margin-top: 20px"
                  >
                    <div class="row">
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="ivType != 'parent'"
                      >
                      <button
                        class="btn btn-block btn-player-content"
                        v-on:click="toggleAISummary"
                        data-cy="interviewOpenAISummary"
                      >
                        <div style="display: flex; align-items: center">
                          <img
                            src="../assets/icon-ai-magic-wand.svg"
                            width="32px"
                            style="margin-left: -10px;"
                          />
                          <div style="width: 100%" class="text-center">
                            AI-GENERATED SUMMARY
                          </div>
                        </div>
                      </button>

                      </div>

                      <!-- AI Summary Content (shows when expanded) -->
                      <div
                        v-if="showAISummary" 
                        class="col-xs-offset-1 col-xs-10"
                        style="margin-bottom: 15px"
                      >
                        <!-- Loading spinner -->
                        <div v-if="isLoadingSummary" class="text-center" style="padding: 20px;">
                          <i class="fa fa-spinner fa-spin fa-3x"></i>
                          <p>Generating summary...</p>
                        </div>
                        
                        <!-- Summary content -->
                        <!-- Summary content -->
                        <div v-else class="interview-summary-content" style="max-height: 300px; overflow-y: auto; padding: 15px; margin-bottom: 15px; border: 1px solid #e4e5e5; border-radius: 5px; background-color: #f9f9f9;">
                          <!-- If we have structured data, display it nicely -->
                          <div v-if="summaryData && summaryData.thematic_summary">
                            <h4 style="font-weight: bold; margin-bottom: 15px;">THEMATIC SUMMARY</h4>
                            <div v-if="Array.isArray(summaryData.thematic_summary)">
                              <!-- Handle array format (new format) -->
                              <div v-for="(item, index) in summaryData.thematic_summary" :key="index" style="margin-bottom: 15px;">
                                <h5 style="font-weight: bold; color: #e96724;">{{ item.theme }}</h5>
                                <p>{{ item.content }}</p>
                              </div>
                            </div>
                            <div v-else>
                              <!-- Handle object format (old format) -->
                              <div v-for="(description, theme) in summaryData.thematic_summary" :key="theme" style="margin-bottom: 15px;">
                                <h5 style="font-weight: bold; color: #e96724;">{{ theme }}</h5>
                                <p>{{ description }}</p>
                              </div>
                            </div>
                          </div>
                          <!-- Fallback to plain text if no structured data -->
                          <div v-else style="white-space: pre-line;">
                            {{ interviewSummaryOverride }}
                          </div>
                        </div>

                        <div style="margin-top: 10px; margin-bottom: 15px; text-align: left; font-size: 14px; color: #e96724;">
                          <span style="display: inline-block; margin-right: 5px;">
                            <!-- this is an inline info icon svg. we should probably create a .svg file -->
                            <img
                            src="../assets/icon-info.svg"
                            width="16px"
                          />
                          </span>
                          AI-generated summaries can sometimes fail to capture the essence of an interview the way a video would.
                        </div>                        <!-- Transcript button -->
                        <div class="text-center" style="margin-top: 15px;">
                          <a
                            v-if="showTranscriptButton"
                            href="#"
                            class="transcript-link"
                            v-on:click.prevent="viewInterviewTranscript"
                            style="display: block; text-align: center; margin: 10px auto;"
                          >
                            <i class="fa fa-file-text-o"></i>
                            View Transcript
                          </a>
                          <button
                            type="button"
                            class="btn btn-default"
                            v-on:click="toggleAISummary"
                            style="margin-left: 10px; margin-top: 10px;"
                          >
                            Close Summary
                          </button>
                        </div>
                      </div>
                      
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="ivType != 'parent'"
                      >
                        <b>Get insights into this interview!</b>
                        <br />
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="videometa.enable_video_reply"
                    class="player-content-box col-xs-offset-2 col-xs-8"
                    data-cy="interviewVideoReply"
                    style="border-radius: 10px; margin-top: 30px"
                  >
                    <div class="row">
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="ivType != 'parent'"
                      >
                        <button
                          v-if="inSlateIframe()"
                          class="btn btn-block btn-player-content"
                          data-cy="interviewOpenVideoReply"
                        >
                          <a v-bind:href="getSlateIframeHref()" target="_blank">
                            <div style="display: flex; align-items: center">
                              <img
                                src="../assets/send_video_reply.svg"
                                width="32px"
                              />
                              <div v-if="!responses" style="width: 100%" class="text-center">
                                SEND A VIDEO REPLY
                              </div>
                              <div v-if="responses" style="width: 100%" class="text-center">
                                YOU SENT A VIDEO REPLY
                              </div>
                            </div>
                          </a>
                        </button>
                        <button
                          v-if="!inSlateIframe()"
                          class="btn btn-block btn-player-content"
                          v-on:click="openModal('videoReplyModal')"
                          data-cy="interviewOpenVideoReply"
                        >
                          <div style="display: flex; align-items: center">
                            <img
                              src="../assets/send_video_reply.svg"
                              width="32px"
                            />
                            <div v-if="!responses" style="width: 100%" class="text-center">
                              SEND A VIDEO REPLY
                            </div>
                            <div v-if="responses" style="width: 100%" class="text-center">
                              YOU SENT A VIDEO REPLY
                            </div>
                          </div>
                        </button>
                      </div>
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="ivType != 'parent'"
                      >
                        <b v-if="iverThanks"
                          >This student responded to your video reply with
                          "Thanks"!</b
                        >
                        <b v-if="!responses">Show this student some love!</b>
                      </div>
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="ivType != 'parent' && ivType != 'shared' && videometa.ivType != 'junior'"
                      >
                      </div>
                    </div>
                  </div>
                  <div
                    class="player-content-box col-xs-offset-2 col-xs-8"
                    style="border-radius: 10px; margin-top: 30px"
                  >
                    <div class="row">
                      <div
                        class="col-xs-offset-1 col-xs-10 text-center"
                        style="margin-bottom: 15px"
                        v-show="
                          ivType != 'parent' && !videometa.enable_video_reply
                        "
                      >
                      </div>
                      <div class="col-xs-offset-1 col-xs-10 text-center">
                        <button
                          class="btn btn-block btn-player-content"
                          data-cy="rateStudent"
                          v-on:click="showRating = !showRating"
                        >
                          <div style="display: flex; align-items: center">
                            <span
                              class="glyphicon glyphicon-ok"
                              style="font-size: 32px; color: #e96724"
                            ></span>
                            <div
                              style="width: 100%"
                              class="text-center"
                              v-show="ivType == 'parent'"
                            >
                              RATE THIS STATEMENT
                            </div>
                            <div
                              style="width: 100%"
                              class="text-center"
                              v-show="ivType != 'parent'"
                            >
                              RATE THE STUDENT
                            </div>
                          </div>
                        </button>

                        <div v-show="showRating">
                          <div class="row" v-show="!login">
                            <div class="col-xs-12 text-center">
                              <h3
                                style="
                                  color: #e96724;
                                  margin-top: 0px;
                                  margin-bottom: 15px;
                                "
                              >
                                Log In to Rate
                              </h3>
                            </div>

                            <div class="col-xs-12" v-show="view == 'login'">
                              <form class="form-horizontal">
                                <div class="form-group">
                                  <label
                                    for="inputEmail3"
                                    class="col-xs-4 control-label"
                                    >Email</label
                                  >
                                  <div class="col-xs-8">
                                    <input
                                      type="email"
                                      class="form-control"
                                      id="inputEmail3"
                                      placeholder="admission@example.com"
                                      v-model="loginemail"
                                    />
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label
                                    for="inputPassword3"
                                    class="col-xs-4 control-label"
                                    >Password</label
                                  >
                                  <div class="col-xs-8">
                                    <input
                                      type="password"
                                      class="form-control"
                                      id="inputPassword3"
                                      placeholder="Password"
                                      v-model="loginpassword"
                                    />
                                  </div>
                                </div>
                                <div class="form-group">
                                  <center>
                                    <button
                                      type="submit"
                                      class="btn btn-primary"
                                      v-on:click.prevent="user_login()"
                                    >
                                      CONTINUE
                                    </button>
                                  </center>
                                </div>
                              </form>
                            </div>
                            <div
                              class="col-xs-12"
                              v-show="view == 'enter_code'"
                            >
                              <p>
                                We emailed a <b>verification code</b> to
                                <b>{{ loginemail }}</b>. Enter it below to
                                finish signing in.
                              </p>
                              <form>
                                <div class="form-group">
                                  <input
                                    type="text"
                                    inputmode="numeric"
                                    autocomplete="one-time-code"
                                    maxlength="6"
                                    class="form-control"
                                    placeholder="123456"
                                    v-model="logincode"
                                  />
                                </div>
                                <div class="form-group">
                                  <center>
                                    <button
                                      type="submit"
                                      class="btn btn-primary"
                                      v-on:click.prevent="submitLoginCode()"
                                    >
                                      VERIFY
                                    </button>
                                  </center>
                                </div>
                                <div class="form-group">
                                  <center>
                                    <a
                                      href="#"
                                      v-on:click.prevent="requestNewCode()"
                                      >Didn't get it? Send a new code</a
                                    >
                                  </center>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div class="row" v-show="login">
                            <div class="col-xs-12 text-center">
                              <div
                                style="font-style: italic; margin-top: 15px"
                                id="click_below_to_rate"
                              >
                                Click Below to Rate
                              </div>
                            </div>

                            <div class="col-xs-12">
                              <!-- hidden floating rating system (the marker boxes!)-->
                              <div id="rating" class="" data-cy="rangeScale">
                                <img
                                  style="left: 69px"
                                  :src="
                                    staticaddr +
                                    '/s/img/organization/RatingScale-01.svg'
                                  "
                                />
                                <input id="range42" type="text" />
                              </div>
                              <div id="reviewGuidelinesBox" class="well">
                                <div
                                  class="feedback text-center"
                                  v-on:click="guidelinesOpen = !guidelinesOpen"
                                >
                                  <u><i>See Suggested Guidelines</i></u>
                                </div>
                                <ul
                                  class="list-unstyled"
                                  v-show="guidelinesOpen"
                                  style="margin-top: 10px; text-align: left"
                                >
                                  <li>
                                    5 = Exceptional interview which strongly
                                    supports admission
                                  </li>
                                  <li>
                                    4 = Good interview which should be seen as a
                                    plus
                                  </li>
                                  <li>
                                    3 = Suitable for admission if otherwise
                                    indicated by application
                                  </li>
                                  <li>
                                    2 = Potentially suitable for admission but
                                    only if application otherwise exceptional
                                  </li>
                                  <li>1 = Not suitable for admission</li>
                                </ul>
                              </div>
                              <div class="form-group">
                                <label for="comment">Comments</label>
                                <p
                                  v-for="review in interview.other_reviews"
                                  v-bind:key="review.timestamp"
                                  class="text-left"
                                >
                                  <i>{{ review.reviewer }}</i
                                  >: [{{ review.rating }}] {{ review.comment }}
                                </p>
                                <textarea
                                  class="form-control"
                                  rows="4"
                                  id="comment"
                                  data-cy="rateStudentComments"
                                  v-model="interview.reviewComments"
                                ></textarea>
                              </div>
                              <br />
                              <div class="text-center">
                                <button
                                  v-on:click="sendToFile()"
                                  class="btn btn-primary btn-md btn-orange"
                                  id="saveButton"
                                  data-cy="rateStudentSubmit"
                                >
                                  Send Rating to File:
                                  {{ interview.reviewScore }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="player-content-box col-md-offset-2 col-md-8" style="margin-top: 20px">
                    <div v-show="!feedbackOpen" style="border-radius: 10px">
                      <div class="row text-center">
                        <div
                          class="col-xs-offset-1 col-xs-10"
                          data-cy="rateInterviewer"
                          v-on:click="feedbackOpen = !feedbackOpen"
                        >
                          <div v-if="ivername">
                            <button
                              class="btn btn-block btn-player-content"
                              style="border-color: #ccc"
                            >
                              <div style="display: flex; align-items: center">
                                <img
                                  class="media-object headshot pull-left"
                                  v-bind:src="headshot || headshotPlaceholder"
                                  v-on:error="headshot = ''"
                                  width="52px"
                                />
                                <div
                                  style="width: 297px; margin-left: 12px"
                                  class="text-center"
                                >
                                  <a>MEET OUR INTERVIEWER</a>
                                </div>
                              </div>
                            </button>
                          </div>
                          <div v-if="!ivername">
                            <button class="btn btn-block btn-player-content" style="border-color: #ccc">
                              <div style="display: flex; align-items: center">
                                <div style="width: 100%" class="text-center">
                                  <div v-if="!feedbackSubmitted">
                                    Please provide our interviewer with feedback
                                  </div>
                                  <div v-if="feedbackSubmitted">
                                    Thanks for your feedback!
                                  </div>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-show="feedbackOpen" style="border-radius: 10px">
                      <div v-if="ivername">
                        <div class="row text-center">
                          <div
                            class="col-xs-offset-1 col-xs-10"
                            v-on:click="feedbackOpen = !feedbackOpen"
                          >
                            <img
                              class="media-object headshot pull-left"
                              v-bind:src="headshot || headshotPlaceholder"
                              v-on:error="headshot = ''"
                            />
                            <div style="color: #000; font-style: italic">
                              {{ bio }}
                            </div>
                          </div>
                        </div>
                        <div class="row text-center">
                          <div class="col-xs-offset-1 col-xs-10">
                            <a href="mailto:contact@initialview.com"
                              >Help me connect with {{ ivername }}!</a
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row feedback">
                        <div class="col-xs-offset-1 col-xs-10 text-center">
                          <p v-if="!feedbackSubmitted" style="color: #000">
                            Please provide our interviewer with feedback.
                          </p>
                          <p v-if="feedbackSubmitted" style="color: #000">
                            Thanks for your feedback!
                          </p>
                          <p style="margin-bottom: 10px; color: #000">
                            How was our interviewer?
                          </p>

                          <div class="btn-group text-center">
                            <button
                              type="button"
                              v-bind:class="[
                                'btn',
                                'btn-md',
                                'btn-default',
                                interviewerFeedback == 'Meh' ? 'active' : '',
                              ]"
                              data-cy="rateInterviewerMeh"
                              v-on:click="setInterviewerFeedback('Meh')"
                              onclick="location.href='#iver-comment'"
                            >
                              Meh
                            </button>
                            <button
                              type="button"
                              v-bind:class="[
                                'btn',
                                'btn-md',
                                'btn-default',
                                interviewerFeedback == 'Good' ? 'active' : '',
                              ]"
                              data-cy="rateInterviewerGood"
                              v-on:click="setInterviewerFeedback('Good')"
                              onclick="location.href='#iver-comment'"
                            >
                              Good
                            </button>
                            <button
                              type="button"
                              v-bind:class="[
                                'btn',
                                'btn-md',
                                'btn-default',
                                interviewerFeedback == 'Bravo!' ? 'active' : '',
                              ]"
                              data-cy="rateInterviewerBravo"
                              v-on:click="setInterviewerFeedback('Bravo!')"
                              onclick="location.href='#iver-comment'"
                            >
                              Bravo!
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-offset-1 col-xs-10">
                          <div
                            class="form-group"
                            style="margin-bottom: 10px; color: #000"
                          >
                            <p>
                              Comments
                              <small
                                >(These are anonymous; email us directly if you
                                would like a response)</small
                              >
                            </p>
                            <textarea
                              class="form-control"
                              rows="3"
                              id="iver-comment"
                              data-cy="rateInterviewerComment"
                              v-model="interviewerFeedbackComment"
                              onfocus="$('#send-comment-btn').addClass('btn-orange btn-primary')"
                            ></textarea>
                          </div>
                          <div class="text-center">
                            <button
                              id="send-comment-btn"
                              type="button"
                              class="btn btn-md btn-default"
                              data-cy="rateInterviewerSubmit"
                              v-on:click="
                                setInterviewerFeedback(
                                  interviewerFeedback,
                                  true
                                )
                              "
                              style="text-shadow: none"
                            >
                              Send Comment about Interviewer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <div id="interview_questions_wrapper">
                  <div class="text-center" id="interview_questions_title">
                    <span v-if="videometa.ivType != 'otis'"
                      >INTERVIEW QUESTIONS</span
                    >
                    <span v-if="videometa.ivType == 'otis'">HIGHLIGHTS</span>
                  </div>
                  <div id="questions">
                    <ul
                      style="
                        list-style-type: none;
                        margin-right: 1em;
                        padding-left: 40px;
                      "
                    >
                      <li
                        v-for="q in videometa.ivVideoData.questions"
                        v-bind:key="q.index"
                        v-on:click.prevent="selectQuestion(q)"
                        v-bind:data-cy="'interviewQuestion-' + q.index"
                      >
                        <div
                          id="questionParent"
                          v-bind:class="
                            q.class +
                            (q.index == currentVideoQuestionId ? ' live' : '')
                          "
                          v-bind:data-question-index="q.index"
                        >
                          <div class="number" v-bind:class="q.class">
                            <p v-bind:data-cy="'questionIndex-' + q.index" style="margin-left: 1em; margin-top: -0.3em">
                              {{ q.index }}
                            </p>
                          </div>
                          <div class="question" v-bind:data-cy="'questionText-' + q.index">
                            <b
                              >({{ Math.floor(q.time / 60) }}:{{
                                secondsEquation(q.time)
                              }})</b
                            >
                            {{ q.text }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-bind:class="{ 'four-tab-radius': fourTabs }"
              class="row tab-area-row"
              v-show="current_tab == 'echo'"
            >
              
              <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <div v-if="echoData && echoData.video_url" style="margin-top: 20px;">
                  <video
                    v-if="echoData && echoData.video_url"
                    :src="echoData.video_url"
                    controls
                    style="width: 100%; max-width: 600px;"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
                
                <div v-else-if="echoData" class="text-center text-muted" style="margin-top: 50px; padding: 40px; background: #f5f5f5; border-radius: 5px;">
                  <span class="glyphicon glyphicon-facetime-video" style="font-size: 48px; color: #ccc; display: block; margin-bottom: 15px;"></span>
                  Video recommendation not yet available.
                </div>
                
                <div v-else class="text-center text-muted" style="margin-top: 50px; padding: 40px;">
                  Loading Echo recommendation data...
                </div>
              </div>

              <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <div style="margin-top: 20px;" v-if="echoData">
                  <div style="background: #f8f9fa; padding: 20px; border-radius: 5px; margin-bottom: 20px;">
                    <h4 style="margin-top: 0; color: #333; font-weight: bold;">Recommendation Details</h4>
                    
                    <div style="margin-bottom: 15px;">
                      <strong>Recommender Name:</strong>
                      {{ echoData.rec_name }}
                    </div>
                    
                    <div style="margin-bottom: 15px;">
                      <strong>Role:</strong>
                      <span class="text-capitalize"> {{ echoData.rec_type }}</span>
                    </div>
                    
                    <div style="margin-bottom: 15px;" v-if="echoData.subject_taught">
                      <strong>Subject Taught:</strong>
                      {{ echoData.subject_taught }}
                    </div>

                    <div style="margin-bottom: 15px;" v-if="echoData.rec_email">
                      <strong>Email:</strong>
                      {{ echoData.rec_email }}
                    </div>

                    <div style="margin-bottom: 0;">
                      <strong>FERPA Waiver:</strong>
                      <span v-if="echoData.ferpa_waived"> 
                        Waived
                      </span>
                      <span v-else>
                        Not Waived
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="needHelp"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
              style="z-index: 1000001"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">We're here to help!</h4>
                  </div>
                  <div class="modal-body">
                    <p>
                      If you're having any trouble, write us a message below or
                      email us at amelia@initialview.com!
                    </p>
                    <div class="form-group">
                      <textarea
                        class="form-control"
                        v-model="supportMessage"
                        rows="3"
                        placeholder="For example: The interview for Suzie Suzeman is not loading (her email is suzie.suzemeister@gmail.com). I’ll also email you a screenshot of the issue. I am using Chrome Version 62 on a Mac."
                      >
                      </textarea>
                    </div>
                    <div class="form-group" v-if="!(user && user.email)">
                      <input
                        type="text"
                        class="form-control"
                        v-model="supportEmail"
                        placeholder="Your Email"
                      />
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <button
                          class="btn btn-success pull-right"
                          v-bind:disabled="!supportMessage || !supportEmail"
                          v-on:click="submitSupport()"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    <div v-if="supportMessageSent" class="row">
                      <div class="col-xs-12">
                        We've received your message! We’re monitoring these
                        messages 24 hours a day. We’ll be in touch soon!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="starreport"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
              style="z-index: 1000001"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      Star Report for the Current Admissions Cycle
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div id="star-modal-container"></div>
                    <table class="table table-striped table-bordered">
                      <tbody>
                        <tr>
                          <td>
                            Total Stars (as of today's date)
                            <i
                              class="glyphicon glyphicon-info-sign"
                              data-toggle="tooltip"
                              data-container="#star-modal-container"
                              title="Each interviewee receives only two virtual stars to assign to target schools"
                            ></i>
                          </td>
                          <td>
                            {{ starreport.total_stars }}
                          </td>
                        </tr>
                        <tr>
                          <td>Total Interviews (as of today's date)</td>
                          <td>
                            {{ starreport.total_interviews }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Current Star Ratio
                            <i
                              class="glyphicon glyphicon-info-sign"
                              data-toggle="tooltip"
                              data-container="#star-modal-container"
                              title="Total number of stars divided by total number of interviews"
                            ></i>
                          </td>
                          <td>
                            {{ starreport.star_ratio }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <a
                        data-toggle="tooltip"
                        data-container="#star-modal-container"
                        data-placement="right"
                        title="The best way to increase your stars is to gently remind students to send their interview (many use language similar to the following in an email: “If you have already completed your InitialView interview, please don’t forget to send it to us”)."
                      >
                        Tips for Increasing Number of Stars
                        <i class="glyphicon glyphicon-info-sign"></i>
                      </a>
                    </p>
                    <p>Interviews from students located in:</p>
                    <div style="max-height: 300px; overflow-y: scroll">
                      <table class="table table-striped table-bordered">
                        <tbody>
                          <tr
                            v-for="region in starreport.interviews_by_region"
                            v-bind:key="region.name"
                          >
                            <td>
                              {{ region.name }}
                            </td>
                            <td>
                              {{ region.count }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal"
        id="videoReplyModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" id="videoReplyModalContent">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="myModalLabel">
                Send Personalized Video Message to {{ videometa.user }}
              </h4>
            </div>
            <div class="modal-body">
              <InterviewResponse
                :selectedInterview="videometa"
                @iverThanks="setIverThanks"
                @componentAlert="handleComponentAlert"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- end videoReplyModal -->

      <div
        class="modal"
        id="videoReplyReport"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" id="videoReplyModalContent">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="myModalLabel">
                Video Reply Engagement Rates
              </h4>
            </div>
            <div class="modal-body">
              <table class="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <td>Total Video Replies</td>
                    <td>
                      {{ videoReplies.total }}
                    </td>
                  </tr>
                  <tr>
                    <td>Viewed Video Replies</td>
                    <td>
                      {{ videoReplies.viewed }}
                    </td>
                  </tr>
                  <tr>
                    <td>Responses of "Thanks"</td>
                    <td>
                      {{ videoReplies.thanks }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end videoReplyModal -->

      <div class="container" v-show="loginRequired">
        <div class="row">
          <div class="col-sm-4 col-sm-offset-4 text-center">
            Login Required to Continue
          </div>
        </div>
        <div class="row" v-show="view == 'login'">
          <div class="col-sm-6 col-sm-offset-3">
            <form class="form-horizontal">
              <div class="form-group">
                <label for="inputEmail4" class="col-xs-4 control-label"
                  >Email</label
                >
                <div class="col-xs-8">
                  <input
                    type="email"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="admission@example.com"
                    v-model="loginemail"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="inputPassword4" class="col-xs-4 control-label"
                  >Password</label
                >
                <div class="col-xs-8">
                  <input
                    type="password"
                    class="form-control"
                    id="inputPassword4"
                    placeholder="Password"
                    v-model="loginpassword"
                  />
                </div>
              </div>
              <div class="form-group">
                <center>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    v-on:click.prevent="user_login()"
                  >
                    LOG IN
                  </button>
                </center>
              </div>
            </form>
          </div>
        </div>

        <div class="row" v-show="view == 'enter_code'">
          <div class="col-sm-6 col-sm-offset-3">
            <p class="text-center">
              We emailed a <b>verification code</b> to <b>{{ loginemail }}</b>.
              Enter it below to finish signing in.
            </p>
            <form class="form-horizontal">
              <div class="form-group">
                <label for="inputLoginCode2" class="col-xs-4 control-label"
                  >Code</label
                >
                <div class="col-xs-8">
                  <input
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    maxlength="6"
                    class="form-control"
                    id="inputLoginCode2"
                    placeholder="123456"
                    v-model="logincode"
                  />
                </div>
              </div>
              <div class="form-group">
                <center>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    v-on:click.prevent="submitLoginCode()"
                  >
                    VERIFY
                  </button>
                </center>
              </div>
              <div class="form-group">
                <center>
                  <a href="#" v-on:click.prevent="requestNewCode()"
                    >Didn't get it? Send a new code</a
                  >
                </center>
              </div>
            </form>
          </div>
        </div>
      </div>

      <nav
        class="navbar navbar-default navbar-fixed-bottom navbar-bottom"
        role="navigation"
      >
        <div class="container text-center">
          <p class="col-xs-12 navbar-text">
            <span>&copy; InitialView {{ currentYear }}</span
            ><span style="margin: 0 10px 010px">|</span>
            <a
              href="#"
              data-toggle="modal"
              data-target="#needHelp"
              style="color: #777"
            >
              <i class="glyphicon glyphicon-question-sign"></i>
              Having trouble with anything?
            </a>
          </p>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);

import NavTools from "@/components/NavTools.vue";
import HSProfile from "@/components/HSProfile.vue";
import IVPlayer from "@/components/IVPlayer.vue";
import ivbus from "@/utils/ivbus.js";

import {
  ivAlertMixin,
  ivSpinnerMixin,
  ivUserInfoMixin,
  ivModalMixin,
  ivPlayerMixin,
  getParameterByName,
  setSessionStorageApiToken,
} from "@/mixins/base-components-pack.js";

import { orgSupportMixin } from "@/mixins/org-support-mixin-pack.js";
import apiClient from "../utils/apiClient.js";
import ionRangeSlider from "ion-rangeslider";
import Alert from "../components/Alert.vue";
import Spinner from "../components/Spinner.vue";
import InterviewResponse from "@/components/InterviewResponse.vue";
import env from "../utils/env.js";
import headshotPlaceholder from "../assets/headshot-placeholder.svg";

require("../assets/video-js.css");
require("../assets/iv-player.css");
require("../assets/player.css");

var vparam = getParameterByName("v");

var urlAddVparam = "";
if (vparam !== null) {
  urlAddVparam = "?v=" + vparam;
}

function makeid(length) {
  var result = "";
  //~ var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default {
  props: ["staticaddr", "serveraddr", "ameliaaddr", "lang", "lang_label"],
  mixins: [
    ivAlertMixin,
    ivSpinnerMixin,
    ivModalMixin,
    ivUserInfoMixin,
    orgSupportMixin,
    ivPlayerMixin,
  ],
  components: {
    NavTools,
    IVPlayer,
    HSProfile,
    Alert,
    Spinner,
    InterviewResponse,
  },

  computed: {
    fourTabs: function () {
      var a = this.ivResume != "";
      console.log(a);
      var b = this.ivSummary != "";
      console.log(b);
      var c = this.ivWriting != "";
      console.log(c);
      var d = this.ivHSProfile != "";
      console.log(d);
      var e = this.ivWritingEval != "";
      console.log(e);
      var sum = a + b + c + d + e + 1; //2 currently represents 1) interview video and 2) hs profile
      console.log(sum);
      if (sum == 4) {
        return true;
        console.log("true");
      } else {
        return false;
        console.log("false");
      }
    },
  },

  data() {
    return {
      env: env,
      currentYear: new Date().getFullYear(),
      componentAlerts: {},
      interview: {
        send: "",
        sendId: "",
        email: "",
        reviewStatus: 0,
        reviewScore: null, //user unique
        reviewScoreAve: "4.5",
        reviewComments: "",
        other_reviews: [],
      },

      appEmail: "",
      current_school: "",
      applicationIds: [],
      cbo_name: "",
      cbo_profile_img: "",
      cbo_profile_pdf: "",
      gaokao_data: {},
      csat_data: {},
      hsCity: "",
      hsState: "",
      grades: "",
      sizes: [],
      interests: [],
      geographies: [],
      ai_summary: "",

      gradeLabels: {
        A: { label: "All As", show: false },
        Ab: { label: "Mostly As and some Bs", show: false },
        aB: { label: "Some As and mostly Bs", show: false },
        Bc: { label: "Mostly Bs and some Cs", show: false },
        C: { label: "Mostly Cs", show: false },
        X: { label: "Mostly below Cs", show: false },
        NA: { label: "I’d prefer not to share", show: false },
        //~ ]),
      },
      // See line 579 in amelia/EpicProfile.vue
      academicInterests: {
        business: { label: "Business and Finance", show: false },
        "cs-math": {
          label: "Computer Science, Math, and Engineering",
          show: false,
        },
        lang: { label: "Foreign Languages", show: false },
        hum: {
          label: "Humanities (Literature, Geography, History, etc.)",
          show: false,
        },
        "lab-sci": {
          label: "Lab Sciences (Bio, Chem, Physics, etc.)",
          show: false,
        },
        med: { label: "Nursing and Medicine", show: false },
        "perf-art": {
          label: "Performing Arts (Dance, Drama, etc.)",
          show: false,
        },
        "soc-sci": {
          label: "Social Sciences (Economics, Political Science, etc.)",
          show: false,
        },
        "vis-art": {
          label: "Visual Arts (Drawing, Painting, etc.)",
          show: false,
        },
        none: { label: "I don’t know yet", show: false },
      },
      // See line 579 in amelia/EpicProfile.vue
      collegeSize: {
        s: {
          label: "3,500 students or less (small college/university)",
          show: false,
        },
        m: {
          label: "3,500 - 10,000 students (mid-sized university)",
          show: false,
        },
        l: { label: "Over 10,000 students (large university)", show: false },
        x: { label: "No strong preference", show: false },
      },
      // See line 579 in amelia/EpicProfile.vue
      geographicPreference: {
        "West Coast": { label: "West Coast", show: false },
        Midwest: { label: "Midwest", show: false },
        "East Coast": { label: "East Coast", show: false },
        "Big city": { label: "Big city", show: false },
        "Metropolitan area": { label: "Metropolitan area", show: false },
        "Small town or College town": {
          label: "Small town or College town",
          show: false,
        },
        //"Rural area": {label:"Rural area", show: false},
        none: { label: "No strong preference", show: false },
      },
      guidelinesOpen: false,
      settings_school_type: 1,
      settings_school_type_options: [
        {
          text: "Graduate School",
          value: 0,
        },
        {
          text: "Undergrad",
          value: 1,
        },
        {
          text: "Boarding / Day School",
          value: 2,
        },
      ],

      loginRequired: false,
      expiredMessage: "",
      login: false,
      loginpassword: "",
      loginemail: "",
      password: "",
      user_status: "active",
      user_link: "None",
      send_status: "",
      view: "login",
      logincode: "",

      interviewerFeedback: "",
      interviewerFeedbackComment: "",
      feedbackOpen: false,
      feedbackSubmitted: false,

      headshot: "",
      headshotPlaceholder,
      bio: "",
      ivername: "",
      email: "",

      showRating: false,

      ivWritingEval: "",
      writingPrompt: "",

      urlVparam: urlAddVparam,
      ivType: "",
      hsprofile: {
        contacts: [],
        curricula: [],
        emails: [],
        phones: [],
        other_departments: [],
      },

      iverThanks: false,
      responses: 0,
      videoReplies: {},
      showAISummary: false,
      interviewSummaryOverride: "",
      isLoadingSummary: false,
      showTranscriptButton: false,
      summaryData: null,
      echoData: null,
      activeGlimpseTab: 'overview',
    };
  },
  created: function () {
    var that = this;
    ivbus.$on("login-required", function () {
      that.loginRequired = true;
    });
    ivbus.$on("responded", this.setResponseStatus)
  },
  mounted: function () {
    var that = this;
    // this will get called if we were already logged in
    ivbus.getFlagSticky("user", function () {
      that.login = true;
      that.loginRequired = false;
      that.loadReviewData();
      // user_status authenticates with our own token now, so it has to wait until the
      // user flag says we have one. (card #618)
      that.userStatus();
    });
    this.getIverBio();
    this.fetchWritingInfo();
    this.fetchSummaryPdf();
    this.fetchStarReport();
    this.fetchHsProfile();
    this.fetchEchoData();

    that.$on("interviewLoaded", function (vparam) {
      ivbus.sendPostMessageParentEmit("interviewLoaded", vparam); // for others, prepend or otherwise designate with the tab name. but first test to see if this works...
    });
    that.$on("interviewClosed", function (vparam) {
      ivbus.sendPostMessageParentEmit("interviewClosed", vparam);
    });
    that.$emit("interviewLoaded", vparam);
    ivbus.$on("meta-ready", function (videometa) {
      if (videometa.org == "University of Illinois at Urbana-Champaign") {
        that.current_tab = "hsprofile";
      }
      if (videometa.ivType == "writing") {
        if (that.ivWritingEval) {
          that.current_tab = "writing-eval";
        } else {
          that.current_tab = "writing";
        }
      }
      ivbus.setFlag("student_name", videometa.user);
    });

    ivbus.startPostMessageParentListener("https://initialview.com");

    if (getParameterByName("vr") == 1) {
      that.openModal("videoReplyModal");
    }
  },

  methods: {
    setActiveGlimpseTab: function (tab) {
      // Pause videos before switching Glimpse sub-tabs
      if (this.activeGlimpseTab === 'overview') {
        // Pause Glimpse video (IVPlayer with customid="otis")
        try {
          var otisPlayer = videojs('otis');
          if (otisPlayer && !otisPlayer.paused()) {
            otisPlayer.pause();
          }
        } catch (e) {
          // Player might not be initialized yet
        }
      } else if (this.activeGlimpseTab === 'recommendation') {
        // Pause ECHO video (native HTML5 video in recommendation tab)
        var echoVideos = document.querySelectorAll('[data-cy="glimpseVideo"] video, .glimpse-tabs-container ~ div video');
        echoVideos.forEach(function(video) {
          if (!video.paused) {
            video.pause();
          }
        });
      }
      this.activeGlimpseTab = tab;
    },
    showTab: function (tab) {
      // Pause videos before switching main tabs
      if (this.current_tab === 'video') {
        // Pause standard interview video (IVPlayer with default customid)
        try {
          var mainPlayer = videojs('main_video');
          if (mainPlayer && !mainPlayer.paused()) {
            mainPlayer.pause();
          }
        } catch (e) {
          // Player might not be initialized yet
        }
      } else if (this.current_tab === 'echo') {
        // Pause ECHO video in main tabs
        var echoVideos = document.querySelectorAll('[data-cy="echoVideo"] video, .tab-area-row video');
        echoVideos.forEach(function(video) {
          if (!video.paused) {
            video.pause();
          }
        });
      }
      this.current_tab = tab;
    },
    userStatus: function () {
      var that = this;
      console.log("inside userStatus");
      apiClient
        .get(that.serveraddr + "/shield/mercury/user_status/", {
          params: {
            sendId: getParameterByName("v"),
          },
        })
        .then(function (response) {
          Vue.set(that, "user_status", response.data.user_status);
          Vue.set(that, "user_link", response.data.user_link);
          Vue.set(that, "send_status", response.data.send_status);
        })
        .catch(function () {
          // Not signed in, or not a super admin — leave the confirm controls hidden.
          Vue.set(that, "user_status", "active");
        });
    },
    loadReviewData: function () {
      var that = this;
      apiClient.get("/api/user/user_info/").then(function (response) {
        console.log(response.data);
        if (response.data.status === false) {
          that.login = false;
        } else {
          that.login = true;
          that.loginRequired = false;
          if (response.data.organization) {
            // stay here
            apiClient
              .get("/api/org/review/?send=" + getParameterByName("v"))
              .then(function (review) {
                that.interview.reviewScore = review.data.data.rating;
                that.interview.reviewScoreAve = review.data.data.rating_ave;
                that.interview.reviewComments = review.data.data.comment;
                that.interview.email = review.data.data.student_email;
                that.interview.send = review.data.data.send;
                Vue.set(
                  that.interview,
                  "other_reviews",
                  review.data.data.other_reviews
                );

                that.setupRating();
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
            window.location = "/portal/";
          }
        }
      });
    },
    setupRating: function () {
      var r = this.interview.reviewScore;
      $("img").on("dragstart", function (event) {
        event.preventDefault();
      });
      var parent = this;
      $("#range42").ionRangeSlider({
        type: "single",
        min: 1,
        max: 5,
        step: 0.5,
        from: r,
        keyboard: true,
        hide_min_max: true,
        hide_from_to: false,
        grid: false,
        onStart: function (data) {},
        onChange: function (data) {
          // $("#click_below_to_rate").addClass("hide")
          //console.log("onChange");
        },
        onFinish: function (data) {
          $(".irs-single").removeClass("hide");
          parent.updateStudentRating(data.from);
          //console.log("onFinish"+ data.from);
        },
        onUpdate: function (data) {
          //console.log("onUpdate");
        },
      });

      var slider = $("#range42").data("ionRangeSlider");

      if (r == null) {
        $(".irs-single").addClass("hide");
      }
      // $(".irs-bar").addClass("hide");
      // $(".irs-bar-edge").addClass("hide");
      // $(".irs-slider").addClass("hide");
      // slider.update({
      //     from: r
      // });
    },
    // fetchOrgInfo: function() {
    // 	console.log('fetching organization' );
    // 	apiClient.get('/api/user/user_org_info/?v='+getParameterByName("v")).then(function(response) {
    // 	  	this.$set('orgName', response.data.org.org_name );
    // 	}).catch(function(error) {
    // 	  	console.log(error);
    // 	});
    // },
    updateStudentRating: function (newRating) {
      var i = this.interview;
      i.reviewScore = newRating;
    },
    sendToFile: function () {
      var review = {
        send: getParameterByName("v"),
        rating: this.interview.reviewScore,
        comment: this.interview.reviewComments,
      };
      var that = this;
      var messageId = this.showMessage("saving changes...", "alert-warning");
      apiClient
        .post("/api/org/review/", review)
        .then(function () {
          that.hideMessage(messageId);
          that.showMessage("Changes Saved", "alert-success", 3000);
          //setTimeout(function(){
          window.close();
          //}, 0);
        })
        .catch(function (error) {});
    },
    user_login: function () {
      // Entry point, so callers/handlers never accidentally pass a retry flag.
      return this.attemptLogin(false);
    },

    attemptLogin: function (isRetry) {
      var that = this;

      if (!localStorage.login_session && !localStorage.device_token) {
        localStorage.login_session = makeid(30);
      }

      var messageId = that.showMessage(
        "Logging in...",
        "alert-warning",
        that.uiMessageWaitLong
      );

      var spinId = that.spinStart();
      that.$http
        .post("/api/user/api-token-auth/", {
          username: that.loginemail,
          password: that.loginpassword,
          login_session: localStorage.login_session, // only one of these should be set at a time
          device_token: localStorage.device_token,
        })
        .then(function (response) {
          that.spinStop(spinId);
          that.hideMessage(messageId);
          if (response.data.status == 200) {
            if (response.data.token !== undefined) {
              sessionStorage.apitoken = response.data.token;
              that.login = true;
              that.loginRequired = false;
              apiClient.defaults.headers["Authorization"] =
                "Token " + sessionStorage.apitoken;
              that.loadReviewData();
              that.fetchVideoMetadata();

              // and fetch the other calls that are vparam auth'd
              that.fetchWritingInfo();
              that.fetchSummaryPdf();
              that.fetchStarReport();
              that.fetchHsProfile();
              that.fetchEchoData();
            } else {
              that.view = "enter_code";
              if (response.data.device_token) {
                localStorage.device_token = response.data.device_token;
                localStorage.removeItem("login_session");
              }
            }
          } else {
            // status 99 means the stored login_session/device_token is stale -
            // the device trust expired, or the row was cleared server-side. Drop
            // it and start a clean login once, rather than making the user press
            // Login again.
            localStorage.removeItem("login_session");
            localStorage.removeItem("device_token");
            if (!isRetry) {
              return that.attemptLogin(true);
            }
            that.showMessage(
              "Oops, that didn't work! Please refresh the page and try again. If the problem persists, contact us at contact@initialview.com for assistance!",
              "alert-danger",
              that.uiMessageWaitLong
            );
          }
        })
        .catch(function (response) {
          that.hideMessage(messageId);
          that.showMessage(
            "Invalid email or password.",
            "alert-danger",
            that.uiMessageWaitLong
          );
          that.spinStop(spinId);
        });
    },

    submitLoginCode: function () {
      var that = this;
      if (!that.logincode) {
        that.showMessage(
          "Please enter the code from your email.",
          "alert-danger",
          that.uiMessageWaitLong
        );
        return;
      }
      var spinId = that.spinStart();
      that.$http
        .post("/api/user/verify_login_code/", {
          device_token: localStorage.device_token,
          code: that.logincode,
        })
        .then(function (response) {
          that.spinStop(spinId);
          if (response.data.status == 200) {
            // Code accepted: the device is activated, so logging in returns a token.
            that.user_login();
          } else if (response.data.code_locked) {
            // the fifth wrong guess cancels the code server-side (card 652).
            that.showMessage(
              "Too many incorrect codes, so that code has been cancelled. Send a new code to try again.",
              "alert-danger",
              that.uiMessageWaitLong
            );
          } else {
            that.showMessage(
              "That code didn't work. Check it and try again, or send a new one.",
              "alert-danger",
              that.uiMessageWaitLong
            );
          }
        })
        .catch(function () {
          that.spinStop(spinId);
          that.showMessage(
            "That code didn't work. Check it and try again.",
            "alert-danger",
            that.uiMessageWaitLong
          );
        });
    },

    requestNewCode: function () {
      // Re-run the login with a fresh session so the server issues a new code.
      this.logincode = "";
      localStorage.removeItem("device_token");
      localStorage.removeItem("login_session");
      this.showMessage(
        "Sending a new code to your email...",
        "alert-warning",
        this.uiMessageWaitLong
      );
      this.user_login();
    },

    getIverBio: function () {
      var that = this;
      apiClient
        .get("/api/user/interviewer_info/" + urlAddVparam)
        .then(function (response) {
          console.log(response.data);
          if (response.data.status !== 200) {
            that.headshot = false;
            that.bio = "Error loading interviewer information";
            that.ivername = false;
            that.email = "#";
          } else {
            that.headshot = response.data.interviewer.iver_headshot;
            that.bio = response.data.interviewer.iver_bio;
            that.ivername = response.data.interviewer.iver_name;
            that.email = "mailto:" + response.data.interviewer.iver_email;
          }
        });
    },
    setInterviewerFeedback: function (feedback, close) {
      var that = this;
      this.interviewerFeedback = feedback;
      var data = {
        send: vparam,
        feedback: this.interviewerFeedback,
        comment: this.interviewerFeedbackComment,
      };
      apiClient.post("/api/org/review/iv/feedback/", data).then(function () {
        if (close) {
          that.feedbackOpen = false;
          that.feedbackSubmitted = true;
        }
      });
    },

    fetchWritingInfo: function () {
      var that = this;
      console.log("fetching writing");
      apiClient
        .get("/api/interview/writing_info/" + urlAddVparam)
        .then(function (response) {
          console.log(response);
          if (response.data.status == "200") {
            that.ivWriting = response.data.url;
            that.ivResume = response.data.resumeUrl;
            that.ivWritingEval = response.data.writing_eval;
            that.writingPrompt = response.data.writing_prompt;
          } else {
            that.ivWriting = "";
            if (response.data.expired) {
              that.expiredMessage = response.data.message;
            }
            console.log(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fetchEchoData: function () {
      var that = this;
      console.log("fetching echo data");
      apiClient
        .get("/api/sourceorg/echo_data/", {
          params: {
            sendId: getParameterByName("v"),
          },
        })
        .then(function (response) {
          console.log("echo response:", response);
          if (response.data.status === 200) {
            that.echoData = response.data.data;
            if (that.echoData && that.echoData.video_url) {
              that.echoData.video_url = env.serverAddr + that.echoData.video_url;
            }
            if (that.echoData && that.echoData.rec_type) {
              let rec_type_dict = {
                'teacher': 'Teacher',
                'counselor': 'Counselor',
                'community_member': 'Community Member',
                'faculty_member': 'Faculty Member'
              };
              that.echoData.rec_type = rec_type_dict[that.echoData.rec_type];
            }
          } else {
            console.log("Echo data not available:", response.data.error);
            that.echoData = null;
          }
        })
        .catch(function (error) {
          console.log("Echo data fetch error:", error);
          that.echoData = null;
        });
    },
    fetchSummaryPdf: function () {
      var that = this;
      console.log("fetching summary");
      apiClient
        .get("/api/interview/summary_info/" + urlAddVparam)
        .then(function (response) {
          console.log(response);
          if (response.data.status == "200") {
            that.ivSummary = response.data.url;
            that.appEmail = response.data.email;
            that.current_school = response.data.current_school;
            that.applicationIds = response.data.applicationIds;
            that.cbo_name = response.data.cbo_name;
            that.cbo_profile_img = response.data.cbo_profile_img;
            that.cbo_profile_pdf = response.data.cbo_profile_pdf;
            that.ivType = response.data.ivType;

            that.hsCity = response.data.hsCity;
            that.hsState = response.data.hsState;
            that.grades = response.data.grades;
            that.interests = response.data.interests.split(":|:");
            that.sizes = response.data.sizes.split(":|:");
            that.geographies = response.data.geographies.split(":|:");

            Vue.set(that, "gaokao_data", response.data.gaokao_data);
            Vue.set(that, "csat_data", response.data.csat_data);
          } else {
            that.ivSummary = "";
            console.log(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fetchStarReport: function () {
      var that = this;
      console.log("fetching star report");
      apiClient
        .get("/api/interview/star_report/" + urlAddVparam)
        .then(function (response) {
          console.log(response);
          if (response.data.status == "200") {
            Vue.set(that, "starreport", response.data.data);
          } else {
            that.starreport = {};
            console.log(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fetchHsProfile: function (uid) {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .get(
          "/api/hsprofile/hsprofile/" + urlAddVparam + (uid ? "&p=" + uid : "")
        )
        .then(function (response) {
          that.spinStop(spinId);
          if (response.data.status == "200") {
            if (response.data.data.hs_name) {
              Vue.set(that, "hsprofile", response.data.data);
              ivbus.setFlag("hsprofile", response.data.data);
              Vue.set(that, "ivHSProfile", "exists");
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    confirmThisSend: function () {
      var that = this;
      if (that.send_status == "SENT") {
        return;
      }
      apiClient
        .post(that.serveraddr + "/shield/mercury/confirm_send/", {
          sendIds: [getParameterByName("v")],
        })
        .then(function (response) {
          if (response.data.status == 200) {
            // window.close() is ignored on tabs the script didn't open, so also
            // flip the button to "Already sent" for the stay-open case.
            that.send_status = "SENT";
            that.showMessage(response.data.message, "alert-success", 2000);
            that.$emit("interviewClosed", vparam);
            window.close();
          } else {
            that.showMessage(response.data.message, "alert-danger", 10000);
          }
        });
    },

    confirmAllSends: function () {
      var that = this;
      apiClient
        .post(that.serveraddr + "/shield/mercury/confirm_all_sends_for_user/", {
          sendIds: [getParameterByName("v")],
        })
        .then(function (response) {
          if (response.data.status == 200) {
            // Confirm-all can skip sends locked behind unapproved app IDs, so
            // re-fetch rather than assume this one is now SENT.
            that.userStatus();
            that.showMessage(response.data.message, "alert-success", 2000);
            that.$emit("interviewClosed", vparam);
            window.close();
          } else {
            that.showMessage(response.data.message, "alert-danger", 10000);
          }
        });
    },

    skipAndClose: function () {
      this.$emit("interviewClosed", vparam);
      window.close();
    },

    regenerateFrame: function () {
      var that = this;
      apiClient
        .post(
          that.serveraddr +
            "/api/iiab/regenerate_frame/",{sid: vparam})
        .then(function (response) {
          if (response.data.status == 200) {
            that.showMessage(response.data.message, "alert-success", 4000);
          } else {
            that.showMessage(response.data.message, "alert-danger", 10000);
          }
        });
    },

    rotateVideo: function (direction) {
      var that = this;
      apiClient
        .post(
          that.serveraddr +
            "/api/iiab/rotate_video/",{sid: vparam, dir: direction})
        .then(function (response) {
          if (response.data.status == 200) {
            that.showMessage(response.data.message, "alert-success", 4000);
          } else {
            that.showMessage(response.data.message, "alert-danger", 10000);
          }
        });
    },

    inSlateIframe: function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },

    getSlateIframeHref: function () {
      try {
        return location.href + "&vr=1";
      } catch (e) {
        return "";
      }
    },
    handleComponentAlert: function (alert) {
      if (this.componentAlerts[alert.name]) {
        this.componentAlerts[alert.name].text = alert.text;
        this.componentAlerts[alert.name].classes = alert.classes;
        this.componentAlerts[alert.name].timeout = alert.timeout;
      } else {
        this.componentAlerts[alert.name] = this.showMessage(alert.text, alert.classes, alert.timeout)
      };
      if (alert.timeout) {
        const message = {
          id: this.componentAlerts[alert.name].id,
          classes: alert.classes,
          text: alert.text,
          timeout: alert.timeout
        };
        setTimeout(() => {
          this.componentAlerts[alert.name] = this.hideMessage(message);
        }, alert.timeout);
      };
    },
    setIverThanks: function (thanks) {
      this.iverThanks = thanks;
    },
    setResponseStatus: function(responses) {
      this.responses = responses;
      console.log("Set responses to " + this.responses)
    },
    secondsEquation: function (time) {
      // prepend 0 if less than 10
      if (time % 60 < 10) {
        return "0" + (time % 60);
      } else {
        return time % 60;
      }
    },
    toggleAISummary: function() {
      var that = this;
      console.log("AmeliaRevStudent.vue. toggleAISummary.");
      
      // Toggle the visibility
      that.showAISummary = !that.showAISummary;
      
      // console.log("AmeliaRevStudent.vue. toggleAISummary. that.showAISummary: ", that.showAISummary);
      // console.log("AmeliaRevStudent.vue. toggleAISummary. that.interviewSummaryOverride: ", that.interviewSummaryOverride);

      // If we're showing the summary and it hasn't been loaded yet, fetch it
      if (that.showAISummary && that.summaryData === null && that.interviewSummaryOverride === "") {
        that.fetchInterviewSummary();
      }
    },

    fetchInterviewSummary: function() {
      var that = this;
      that.isLoadingSummary = true;
      that.showTranscriptButton = true;
      
      // console.log("AmeliaRevStudent.vue. fetchInterviewSummary.");
      
      apiClient.get("/api/interview/ai_summary/" + urlAddVparam)
        .then(function(response) {
          if (response.data.status == "200") {
            that.interviewSummaryOverride = response.data.override;
            
            // Store the structured summary data if available
            if (response.data.raw_data &&
                response.data.raw_data.thematic_summary) {
              that.summaryData = response.data.raw_data;
            } else {
              that.summaryData = null;
            }
            console.log("AmeliaRevStudent.vue. fetchInterviewSummary. that.summaryData: ", that.summaryData)
            that.showTranscriptButton = true;
          } else {
            that.interviewSummaryOverride = "Sorry, we couldn't generate a summary for this interview.";
            that.summaryData = null;
          }
          that.isLoadingSummary = false;
        })
        .catch(function(error) {
          console.log(error);
          that.interviewSummaryOverride = "An error occurred while generating the summary.";
          that.summaryData = null;
          that.isLoadingSummary = false;
        });
    },


    viewInterviewTranscript: function() {
      var that = this;
      window.open("/interview-transcript/?v=" + getParameterByName("v"), "_blank");
    }

  },
};
</script>

<style lang="scss">
.vjs-picture-in-picture-control {
  visibility: hidden !important;
}
.four-tab-radius {
  border-radius: 0 0 10px 10px !important;
}

#viewfinder {
  width: 100%;
  transform: scale(-1, 1);
  border: 3px #e96724 dashed;
}

#player {
  background-color: #fff;
}

/*#interviewee_name {
	margin-top:0px;
	padding-left:20px;
	padding-bottom:0px;
	color: #333;
	font-size: 28px;
	text-align: left;
}
*/

/*#student-info-area {
	margin-bottom:40px;
}
*/

.tab-area-row {
  background-color: #e4e5e5;
  padding-top: 16px;
  margin-top: 0;
  border: solid 2px #ccc;
  box-shadow: 0 0 15px #ccc;
  border-radius: 0 0 10px 10px;
  padding: 10px;
  /*margin-top: -5px;*/
}

.tab-area-row-pdf {
  height: 850px;
}

.tab-area-row-pdf div {
  height: 790px;
}

.headshot {
  min-width: 52px;
  width: 52px;
  height: 52px;
}

.tab-header.tab-header-active {
  box-shadow: 0 15px 0 -2px #e4e5e5, 0 0 15px #ccc;
  border: solid 2px #ccc;
  border-bottom: 0;

  img {
    filter: none;
  }
}

.tab-header {
  border-radius: 10px 10px 0 0;
  padding: 10px;
  text-align: center;
  border: solid 1px #ccc;
  border-bottom: 0;

  img {
    filter: grayscale(1) brightness(0.4);
  }
}

@media (max-width: 768px) {
  .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
  }

  .question {
    margin-left: 5px;
    width: 100%;
  }

  #questions {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 992px) {
  #interview_questions_wrapper {
    margin-top: 10px;
  }
}

/* ELEVEATOR PITCH STYLING */
.ep-recording-header {
  height: 200px;
  margin-top: 15px;
  max-width: 1200px;
  background-color: #e96724;
  border-radius: 15px;
  color: white;
  padding: 25px;
}

.ep-recording-body {
  width: 90%;
  margin-left: 5%;
  margin-top: -6%;
  margin-bottom: 150px;
  background-color: white;
  padding: 5%;
  border: solid 2px #e96724;
  position: relative;
}

.ep-compare {
  font-size: 200%;
  text-align: center;
  display: block;
}
.check {
  color: #e96724;
}
.x {
  color: grey;
}

.orange-font {
  color: #e96724;
}

.overflow-word-break {
  overflow-wrap: break-word;
}

/* CSS FOR Review Template */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Lato";
}
p,
div {
  font-family: "Lato";
}

#videoLoadingBox {
  top: -20px;
  height: 7px;
  /* background:rgba(100,100,255, 0.5); */
}

.progress {
  width: 100%;
  height: 7px;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;

  /* border:1px solid black; */
}

.progress-domino {
  margin-top: 200px;
  /* border:1px solid black; */
}

/* navigation css */

.tab-header-row {
  background-color: #fff;
  margin-top: 0px;
}

.tab-header-row > a {
  flex: 1;
  min-width: 0;
  text-decoration: none;
}

.tab-header {
  background-color: #ebeff1;
  padding: 10px 10px 10px 20px;
  font-size: 12pt;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-header:hover,
.tab-header-active {
  background-color: #e4e5e5;
  color: #e96724;

  img {
    filter: none;
  }
}

/* Responsive adjustments for smaller viewports */
@media (max-width: 768px) {
  .tab-header {
    font-size: 10pt;
    padding: 8px 8px 8px 12px;
  }
}

@media (max-width: 576px) {
  .tab-header {
    font-size: 9pt;
    padding: 6px 6px 6px 8px;
  }
}

.tab-area-row {
  /* slightly darker  */
  background-color: #e4e5e5;
  /*other options #e1e7ea; d2dbe0 #e6e6e6 */
  padding-top: 10px;
  padding-bottom: 20px;
}

/* bio UI */
.media {
  margin-bottom: 10px;
  font-style: italic;
}

.well-close:hover {
  background-image: linear-gradient(to bottom, lightgrey 0%, #f5f5f5 100%);
}

.feedback hr {
  border-color: darkgrey;
  border-width: 3px;
  margin: 10px;
}

/* LIST VIEW */
#list-view {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
  /*   border: solid blue 1px;
  overflow-y:scroll; */
}

.navbar-nav-thin > li > a {
  padding: 18px;
}
.navbar-form-thin {
  margin: 0px;
  padding-top: 10px;
  padding-bottom: 6px;
  height: 56px;
}

.nav-badge {
  padding-top: 18px;
  padding-right: 10px;
  padding-left: 10px;
}

#list-view-nav {
  min-height: 40px;
  margin-bottom: 5px;
  top: -20px;
}

#listPageSearchInput {
  width: 300px;
}

th.sortable:hover {
  background-color: #222;
}

thead {
  background-color: #444;
  color: #eee;
}

.nowrap {
  white-space: nowrap;
}

.centerLinks {
  text-align: center;
}

#list-dropdown {
  width: 100px;
}

.list-star > img {
  display: block;
  margin: auto;
}

.sorted-column {
  background-color: black;
}

td.review-score {
  font-size: 24pt;
  text-align: center;
}

/*video interview section */

.back-ten-seconds, .skip-ten-seconds {
  width: 15px;
}

.star-text {
  margin-top: 0px;
  margin-left: 40px;
  /* padding-bottom:10px; */
  color: #333;
  font-size: 14px;
  text-align: left;
}

.rose_text {
  margin-top: 0px;
  margin-left: 40px;
  padding-bottom: 10px;
  color: #333;
  font-size: 14px;
  text-align: left;
}

#interview_questions_title {
  color: #555;
  font-size: 20px;
  text-align: center;
  top: -5px;
  margin: 10px 10px 10px 10px;
}

#interview_questions_wrapper {
  border: solid 2px #ccc;
  box-shadow: 0px 0px 15px #ccc;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
  min-height: 470px !important;
  height: 80vh !important;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  max-height: 900px !important;
}

hr {
  border-color: #bbb;
  border-width: 3px;
  margin: 20px;
}

.leaveSpaceForControls {
  height: 50px;
}

/*rate interviewer */
.feedback:hover {
  color: #e96724;
}

.feedback {
  color: black;
}

.guidelines {
  color: black;
}

/* video reply modal */

.modal-dialog:has(#videoReplyModalContent) {
  width: 60vw;
}

#videoReplyModalContent {
  height: 90vh;
}

/* */

.player-content-box {
  border: solid 2px #ccc;
  box-shadow: 0px 0px 15px #ccc;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
}

.btn-player-content {
  border: 4px solid #e96724;
  border-radius: 12px;
  display: block;
  background-color: #fff;
  opacity: 1;
  color: #777;
}

/* rate student */

#rate_student_title {
  margin-top: 12px;
  color: #eeeeee;
  font-size: 15pt;
  text-align: center;
}

#rate-student .tab-area-row {
  padding-top: 10px;
  color: #eeeeee;
  background: #79a9ad;
}

.centeredDiv {
  display: block;
  margin: auto;
  padding: 2px;
  margin-bottom: 5px;
}

#rating {
  /* border: 1px solid #293237; */
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 5px;
  width: 183px;
  height: 70px;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

#rating > img {
  position: absolute;
  margin-left: 0px;
  margin-top: 18px;
  width: 185px;
}

.irs-single {
  background-color: #e96724;
  padding: 5px;
  margin-top: 13px;
}

.irs-line {
  position: relative;
  display: inline-block;
  margin: auto;
  height: 70px;
  /* background-color: #e96724; */
  padding: 0px;
}

#ratingMarkerNumber {
  color: white;
  position: absolute;
  top: 6px;
  left: 14px;
  width: 100%;
}

.slider {
  margin-top: 0px;
  margin-bottom: 5px;
  margin-right: 0px;
  margin-left: 0px;
  height: 60px;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.slider li {
  /* border:black 1px dotted; */
  background-repeat: no-repeat;
  background-image: none;
  background-position: top center;
  float: left;
  width: 37px;
  height: 60px;
  z-index: 100;
  position: relative;
}

.ratingScale {
  position: relative;
  display: block;
  margin: auto;
  /* make sure it's less than width:186px; */
  width: 170px;
  padding-bottom: 12px;
}

/* slider marker image */
.slider li img {
  padding-top: 0px;
  padding-left: 0px;
  display: block;
  margin: auto;
  width: 29px;
}

#reviewGuidelines {
  font-size: 9pt;
}

#reviewGuidelinesBox {
  background-color: lightgray;
  padding: 5px 5px 5px 5px;
  margin: auto;
  color: #333;
  /* border:2px solid #444; */
  margin-bottom: 15px;
}

#reviewGuidelinesTitle {
  padding: 7px;
  font-size: 10pt;
}

.currentStudentRating {
  display: block;
  border: 1px solid black;
}

.rangeslider,
input[type="range"] {
  max-width: 400px;
}

.rangeslider__handle {
  border-radius: 22px;
  min-width: 62px;
  line-height: 42px;
  text-align: center;
}
/*
#e96724 --orange

#79a9ad --blue

#ebeff1  --almost white backgroudn
*/

/* bootstrap override */
nav {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.dropdown-menu {
  background-color: #ebeff1;
}

.form-control {
  background-color: #ebf1f2;
}

.video-js .vjs-big-play-button:before,
.video-js .vjs-control:before,
.video-js .vjs-modal-dialog,
.vjs-modal-dialog .vjs-modal-dialog-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-js .vjs-big-play-button:before,
.video-js .vjs-control:before {
  text-align: center;
}

/*@font-face {
  font-family: VideoJS;
  src: url("../font/1.4.0/VideoJS.eot?#iefix") format("eot"); }
*/
@font-face {
  font-family: VideoJS;
  src: url(data:application/font-woff;charset=utf-8;base64,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)
      format("woff"),
    url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAAKAIAAAwAgT1MvMlGRXgQAAAEoAAAAVmNtYXDiLxC2AAAB+AAAAUpnbHlm5X8X/gAAA4QAAA7kaGVhZArGdn0AAADQAAAANmhoZWEOogcfAAAArAAAACRobXR40gAAAAAAAYAAAAB4bG9jYTDILUIAAANEAAAAPm1heHABLwB5AAABCAAAACBuYW1l1cf1oAAAEmgAAAIKcG9zdL2sAHoAABR0AAABeQABAAAHAAAAAKEHAAAAAAAHAAABAAAAAAAAAAAAAAAAAAAAHgABAAAAAQAAEXIS2l8PPPUACwcAAAAAANJUFcAAAAAA0lQVwAAAAAAHAAcAAAAACAACAAAAAAAAAAEAAAAeAG0ABwAAAAAAAgAAAAoACgAAAP8AAAAAAAAAAQcAAZAABQAIBHEE5gAAAPoEcQTmAAADXABXAc4AAAIABQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGZFZABA8QHxHQcAAAAAoQcAAAAAAAABAAAAAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAABwAAAAcAAAAHAAAAAAAAAwAAAAMAAAAcAAEAAAAAAEQAAwABAAAAHAAEACgAAAAGAAQAAQACAADxHf//AAAAAPEB//8AAA8AAAEAAAAAAAAAAAEGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AUABmALIAxgDmAR4BSAF0AZwB8gIuAo4CugMKA44DsAPqBDgEfAS4BOgFDAWiBegGNgZsBtoHcgAAAAEAAAAABYsFiwACAAABEQECVQM2BYv76gILAAADAAAAAAZrBmsAAgAOABoAAAkCEwQAAxIABSQAEwIAASYAJzYANxYAFwYAAusBwP5Alf7D/loICAGmAT0BPQGmCAj+Wv7D/f6uBgYBUv39AVIGBv6uAjABUAFQAZsI/lr+w/7D/loICAGmAT0BPQGm+sgGAVL9/QFSBgb+rv39/q4AAAACAAAAAAVABYsAAwAHAAABIREpAREhEQHAASv+1QJVASsBdQQW++oEFgAAAAQAAAAABiAGIAAGABMAJAAnAAABLgEnFRc2NwYHFz4BNSYAJxUWEgEHASERIQERAQYHFT4BNxc3AQcXBNABZVW4A7sCJ3ElKAX+3+Wlzvu3XwFh/p8BKwF1AT5MXU6KO5lf/WCcnAOAZJ4rpbgYGGpbcUacVPQBYziaNP70Aetf/p/+QP6LAfb+wjsdmhJEMZhfBJacnAAAAQAAAAAEqwXWAAUAAAERIQERAQILASoBdv6KBGD+QP6LBKr+iwAAAAIAAAAABWYF1gAGAAwAAAEuAScRPgEBESEBEQEFZQFlVFRl/BEBKwF1/osDgGSeK/2mK54BRP5A/osEqv6LAAADAAAAAAYgBg8ABQAMABoAABMRIQERAQUuAScRPgEDFRYSFwYCBxU2ADcmAOABKwF1/osCxQFlVVVluqXOAwPOpeUBIQUF/t8EYP5A/osEqv6L4GSeK/2mK54C85o0/vS1tf70NJo4AWL19QFiAAAABAAAAAAFiwWLAAUACwARABcAAAEjESE1IwMzNTM1IQEjFSERIwMVMxUzEQILlgF24JaW4P6KA4DgAXaW4OCWAuv+ipYCCuCW/ICWAXYCoJbgAXYABAAAAAAFiwWLAAUACwARABcAAAEzFTMRIRMjFSERIwEzNTM1IRM1IxEhNQF14Jb+iuDgAXaWAcCW4P6KlpYBdgJV4AF2AcCWAXb76uCWAcDg/oqWAAAAAAIAAAAABdYF1gAPABMAAAEhDgEHER4BFyE+ATcRLgEDIREhBUD8gD9VAQFVPwOAP1UBAVU//IADgAXVAVU//IA/VQEBVT8DgD9V++wDgAAABgAAAAAGawZrAAcADAATABsAIAAoAAAJASYnDgEHASUuAScBBSEBNhI3JgUBBgIHFhchBR4BFwEzARYXPgE3AQK+AWROVIfwYQESA4416aH+7gLl/dABelxoAQH8E/7dXGgBAQ4CMP3kNemhARJ4/t1OVIfwYf7uA/ACaBIBAVhQ/id3pfY+/idL/XNkAQGTTU0B+GT+/5NNSEul9j4B2f4IEgEBWFAB2QAAAAUAAAAABmsF1gAPABMAFwAbAB8AAAEhDgEHER4BFyE+ATcRLgEBIRUhASE1IQUhNSE1ITUhBdX7VkBUAgJUQASqQFQCAlT7FgEq/tYC6v0WAuoBwP7WASr9FgLqBdUBVT/8gD9VAQFVPwOAP1X9rJX+1ZWVlZaVAAMAAAAABiAF1gAPACcAPwAAASEOAQcRHgEXIT4BNxEuAQEjNSMVMzUzFRQGByMuAScRPgE3Mx4BFQUjNSMVMzUzFQ4BByMuATURNDY3Mx4BFwWL++o/VAICVD8EFj9UAgJU/WtwlZVwKiDgICoBASog4CAqAgtwlZVwASog4CAqKiDgICoBBdUBVT/8gD9VAQFVPwOAP1X99yXgJUogKgEBKiABKiAqAQEqIEol4CVKICoBASogASogKgEBKiAAAAYAAAAABiAE9gADAAcACwAPABMAFwAAEzM1IxEzNSMRMzUjASE1IREhNSERFSE14JWVlZWVlQErBBX76wQV++sEFQM1lv5AlQHAlf5Alv5AlQJVlZUAAAABAAAAAAYgBmwALgAAASIGBwE2NCcBHgEzPgE3LgEnDgEHFBcBLgEjDgEHHgEXMjY3AQYHHgEXPgE3LgEFQCtKHv3sBwcCDx5OLF9/AgJ/X19/Agf98R5OLF9/AgJ/XyxOHgIUBQEDe1xcewMDewJPHxsBNxk2GQE0HSACf19ffwICf18bGf7NHCACf19ffwIgHP7KFxpcewICe1xdewAAAgAAAAAGWQZrAEMATwAAATY0Jzc+AScDLgEPASYvAS4BJyEOAQ8BBgcnJgYHAwYWHwEGFBcHDgEXEx4BPwEWHwEeARchPgE/ATY3FxY2NxM2JicFLgEnPgE3HgEXDgEFqwUFngoGB5YHGQ26OkQcAxQP/tYPFAIcRTm6DRoHlQcFC50FBZ0LBQeVBxoNujlFHAIUDwEqDxQCHEU5ug0aB5UHBQv9OG+UAgKUb2+UAgKUAzckSiR7CRoNAQMMCQVLLRzGDhEBAREOxhwtSwUJDP79DBsJeyRKJHsJGg3+/QwJBUstHMYOEQEBEQ7GHC1LBQkMAQMMGwlBApRvb5QCApRvb5QAAAAAAQAAAAAGawZrAAsAABMSAAUkABMCACUEAJUIAaYBPQE9AaYICP5a/sP+w/5aA4D+w/5aCAgBpgE9AT0BpggI/loAAAACAAAAAAZrBmsACwAXAAABBAADEgAFJAATAgABJgAnNgA3FgAXBgADgP7D/loICAGmAT0BPQGmCAj+Wv7D/f6uBgYBUv39AVIGBv6uBmsI/lr+w/7D/loICAGmAT0BPQGm+sgGAVL9/QFSBgb+rv39/q4AAAMAAAAABmsGawALABcAIwAAAQQAAxIABSQAEwIAASYAJzYANxYAFwYAAw4BBy4BJz4BNx4BA4D+w/5aCAgBpgE9AT0BpggI/lr+w/3+rgYGAVL9/QFSBgb+rh0Cf19ffwICf19ffwZrCP5a/sP+w/5aCAgBpgE9AT0BpvrIBgFS/f0BUgYG/q79/f6uAk9ffwICf19ffwICfwAAAAQAAAAABiAGIAAPABsAJQApAAABIQ4BBxEeARchPgE3ES4BASM1IxUjETMVMzU7ASEeARcRDgEHITczNSMFi/vqP1QCAlQ/BBY/VAICVP1rcJVwcJVwlgEqICoBASog/tZwlZUGIAJUP/vqP1QCAlQ/BBY/VPyClZUBwLu7ASog/tYgKgFw4AACAAAAAAZrBmsACwAXAAABBAADEgAFJAATAgATBwkBJwkBNwkBFwEDgP7D/loICAGmAT0BPQGmCAj+Wjhp/vT+9GkBC/71aQEMAQxp/vUGawj+Wv7D/sP+WggIAaYBPQE9Aab8EWkBC/71aQEMAQxp/vUBC2n+9AABAAAAAAXWBrYAFgAAAREJAREeARcOAQcuAScjFgAXNgA3JgADgP6LAXW+/QUF/b6+/QWVBgFR/v4BUQYG/q8FiwEq/ov+iwEqBP2/vv0FBf2+/v6vBgYBUf7+AVEAAAABAAAAAAU/BwAAFAAAAREjIgYdASEDIxEhESMRMzU0NjMyBT+dVjwBJSf+/s7//9Ctkwb0/vhISL3+2P0JAvcBKNq6zQAAAAAEAAAAAAaOBwAAMABFAGAAbAAAARQeAxUUBwYEIyImJyY1NDY3NiUuATU0NwYjIiY1NDY3PgEzIQcjHgEVFA4DJzI2NzY1NC4CIyIGBwYVFB4DEzI+AjU0LgEvASYvAiYjIg4DFRQeAgEzFSMVIzUjNTM1MwMfQFtaQDBI/uqfhOU5JVlKgwERIB8VLhaUy0g/TdNwAaKKg0pMMUVGMZImUBo1Ij9qQCpRGS8UKz1ZNjprWzcODxMeChwlThAgNWhvUzZGcX0Da9XVadTUaQPkJEVDUIBOWlN6c1NgPEdRii5SEipAKSQxBMGUUpo2QkBYP4xaSHNHO0A+IRs5ZjqGfVInITtlLmdnUjT8lxo0Xj4ZMCQYIwsXHTgCDiQ4XTtGazsdA2xs29ts2QADAAAAAAaABmwAAwAOACoAAAERIREBFgYrASImNDYyFgERIRE0JiMiBgcGFREhEhAvASEVIz4DMzIWAd3+tgFfAWdUAlJkZ6ZkBI/+t1FWP1UVC/63AgEBAUkCFCpHZz+r0ASP/CED3wEySWJik2Fh/N39yAISaXdFMx4z/dcBjwHwMDCQIDA4H+MAAAEAAAAABpQGAAAxAAABBgcWFRQCDgEEIyAnFjMyNy4BJxYzMjcuAT0BFhcuATU0NxYEFyY1NDYzMhc2NwYHNgaUQ18BTJvW/tKs/vHhIyvhsGmmHyEcKypwk0ROQk4seQFbxgi9hoxgbWAlaV0FaGJFDhyC/v3ut22RBIoCfWEFCxexdQQmAyyOU1hLlbMKJiSGvWYVOXM/CgAAAAEAAAAABYAHAAAiAAABFw4BBwYuAzURIzU+BDc+ATsBESEVIREUHgI3NgUwUBewWWitcE4hqEhyRDAUBQEHBPQBTf6yDSBDME4Bz+0jPgECOFx4eDoCINcaV11vVy0FB/5Y/P36HjQ1HgECAAEAAAAABoAGgABKAAABFAIEIyInNj8BHgEzMj4BNTQuASMiDgMVFBYXFj8BNjc2JyY1NDYzMhYVFAYjIiY3PgI1NCYjIgYVFBcDBhcmAjU0EiQgBBIGgM7+n9FvazsTNhRqPXm+aHfijmm2f1srUE0eCAgGAgYRM9Gpl6mJaz1KDgglFzYyPlYZYxEEzv7OAWEBogFhzgOA0f6fziBdR9MnOYnwlnLIfjpgfYZDaJ4gDCAfGAYXFD1al9mkg6ruVz0jdVkfMkJyVUkx/l5Ga1sBfOnRAWHOzv6fAAAHAAAAAAcABM8ADgAXACoAPQBQAFoAXQAAARE2HgIHDgEHBiYjJyY3FjY3NiYHERQFFjY3PgE3LgEnIwYfAR4BFw4BFxY2Nz4BNy4BJyMGHwEeARcUBhcWNjc+ATcuAScjBh8BHgEXDgEFMz8BFTMRIwYDJRUnAxyEzZRbCA2rgketCAEBqlRoCglxYwF+IiEOIysBAkswHQEECiQ0AgE+YyIhDiIsAQJLMB4BBQokNAE/YyIhDiIsAQJLMB4BBQokNAEBPvmD7kHhqs0s0gEnjgHJAv0FD2a9gIrADwUFAwPDAlVMZ3MF/pUHwgc1HTyWV325PgsJED+oY3G9TAc1HTyWV325PgsJED+oY3G9TAc1HTyWV325PgsJED+oY3G9UmQBZQMMR/61g/kBAAAAAAAQAMYAAQAAAAAAAQAHAAAAAQAAAAAAAgAHAAcAAQAAAAAAAwAHAA4AAQAAAAAABAAHABUAAQAAAAAABQALABwAAQAAAAAABgAHACcAAQAAAAAACgArAC4AAQAAAAAACwATAFkAAwABBAkAAQAOAGwAAwABBAkAAgAOAHoAAwABBAkAAwAOAIgAAwABBAkABAAOAJYAAwABBAkABQAWAKQAAwABBAkABgAOALoAAwABBAkACgBWAMgAAwABBAkACwAmAR5WaWRlb0pTUmVndWxhclZpZGVvSlNWaWRlb0pTVmVyc2lvbiAxLjBWaWRlb0pTR2VuZXJhdGVkIGJ5IHN2ZzJ0dGYgZnJvbSBGb250ZWxsbyBwcm9qZWN0Lmh0dHA6Ly9mb250ZWxsby5jb20AVgBpAGQAZQBvAEoAUwBSAGUAZwB1AGwAYQByAFYAaQBkAGUAbwBKAFMAVgBpAGQAZQBvAEoAUwBWAGUAcgBzAGkAbwBuACAAMQAuADAAVgBpAGQAZQBvAEoAUwBHAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAHMAdgBnADIAdAB0AGYAIABmAHIAbwBtACAARgBvAG4AdABlAGwAbABvACAAcAByAG8AagBlAGMAdAAuAGgAdAB0AHAAOgAvAC8AZgBvAG4AdABlAGwAbABvAC4AYwBvAG0AAAACAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4AAAECAQMBBAEFAQYBBwEIAQkBCgELAQwBDQEOAQ8BEAERARIBEwEUARUBFgEXARgBGQEaARsBHAEdAR4EcGxheQtwbGF5LWNpcmNsZQVwYXVzZQt2b2x1bWUtbXV0ZQp2b2x1bWUtbG93CnZvbHVtZS1taWQLdm9sdW1lLWhpZ2gQZnVsbHNjcmVlbi1lbnRlcg9mdWxsc2NyZWVuLWV4aXQGc3F1YXJlB3NwaW5uZXIJc3VidGl0bGVzCGNhcHRpb25zCGNoYXB0ZXJzBXNoYXJlA2NvZwZjaXJjbGUOY2lyY2xlLW91dGxpbmUTY2lyY2xlLWlubmVyLWNpcmNsZQJoZAZjYW5jZWwGcmVwbGF5CGZhY2Vib29rBWdwbHVzCGxpbmtlZGluB3R3aXR0ZXIGdHVtYmxyCXBpbnRlcmVzdBFhdWRpby1kZXNjcmlwdGlvbgAAAAAA)
      format("truetype");
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play,
.video-js .vjs-big-play-button,
.video-js .vjs-play-control {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play:before,
.video-js .vjs-big-play-button:before,
.video-js .vjs-play-control:before {
  content: "";
}

.vjs-icon-play-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play-circle:before {
  content: "";
}

.vjs-icon-pause,
.video-js .vjs-play-control.vjs-playing {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-pause:before,
.video-js .vjs-play-control.vjs-playing:before {
  content: "";
}

.vjs-icon-volume-mute,
.video-js .vjs-mute-control.vjs-vol-0,
.video-js .vjs-volume-menu-button.vjs-vol-0 {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-mute:before,
.video-js .vjs-mute-control.vjs-vol-0:before,
.video-js .vjs-volume-menu-button.vjs-vol-0:before {
  content: "";
}

.vjs-icon-volume-low,
.video-js .vjs-mute-control.vjs-vol-1,
.video-js .vjs-volume-menu-button.vjs-vol-1 {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-low:before,
.video-js .vjs-mute-control.vjs-vol-1:before,
.video-js .vjs-volume-menu-button.vjs-vol-1:before {
  content: "";
}

.vjs-icon-volume-mid,
.video-js .vjs-mute-control.vjs-vol-2,
.video-js .vjs-volume-menu-button.vjs-vol-2 {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-mid:before,
.video-js .vjs-mute-control.vjs-vol-2:before,
.video-js .vjs-volume-menu-button.vjs-vol-2:before {
  content: "";
}

.vjs-icon-volume-high,
.video-js .vjs-mute-control,
.video-js .vjs-volume-menu-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-volume-high:before,
.video-js .vjs-mute-control:before,
.video-js .vjs-volume-menu-button:before {
  content: "";
}

.vjs-icon-fullscreen-enter,
.video-js .vjs-fullscreen-control {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-fullscreen-enter:before,
.video-js .vjs-fullscreen-control:before {
  content: "";
}

.vjs-icon-fullscreen-exit,
.video-js.vjs-fullscreen .vjs-fullscreen-control {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-fullscreen-exit:before,
.video-js.vjs-fullscreen .vjs-fullscreen-control:before {
  content: "";
}

.vjs-icon-square {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-square:before {
  content: "";
}

.vjs-icon-spinner {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-spinner:before {
  content: "";
}

.vjs-icon-subtitles,
.video-js .vjs-subtitles-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-subtitles:before,
.video-js .vjs-subtitles-button:before {
  content: "";
}

.vjs-icon-captions,
.video-js .vjs-captions-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-captions:before,
.video-js .vjs-captions-button:before {
  content: "";
}

.vjs-icon-chapters,
.video-js .vjs-chapters-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-chapters:before,
.video-js .vjs-chapters-button:before {
  content: "";
}

.vjs-icon-share {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-share:before {
  content: "";
}

.vjs-icon-cog {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-cog:before {
  content: "";
}

.vjs-icon-circle,
.video-js .vjs-mouse-display,
.video-js .vjs-play-progress,
.video-js .vjs-volume-level {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle:before,
.video-js .vjs-mouse-display:before,
.video-js .vjs-play-progress:before,
.video-js .vjs-volume-level:before {
  content: "";
}

.vjs-icon-circle-outline {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle-outline:before {
  content: "";
}

.vjs-icon-circle-inner-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-circle-inner-circle:before {
  content: "";
}

.vjs-icon-hd {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-hd:before {
  content: "";
}

.vjs-icon-cancel,
.video-js .vjs-control.vjs-close-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-cancel:before,
.video-js .vjs-control.vjs-close-button:before {
  content: "";
}

.vjs-icon-replay {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-replay:before {
  content: "";
}

.vjs-icon-facebook {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-facebook:before {
  content: "";
}

.vjs-icon-gplus {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-gplus:before {
  content: "";
}

.vjs-icon-linkedin {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-linkedin:before {
  content: "";
}

.vjs-icon-twitter {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-twitter:before {
  content: "";
}

.vjs-icon-tumblr {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-tumblr:before {
  content: "";
}

.vjs-icon-pinterest {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-pinterest:before {
  content: "";
}

.vjs-icon-audio-description {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-audio-description:before {
  content: "";
}

.video-js {
  display: block;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  font-family: Arial, Helvetica, sans-serif;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.video-js:-moz-full-screen {
  position: absolute;
}
.video-js:-webkit-full-screen {
  width: 100% !important;
  height: 100% !important;
}

.video-js *,
.video-js *:before,
.video-js *:after {
  box-sizing: inherit;
}

.video-js ul {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  list-style-position: outside;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: 100%;
  max-width: 100%;
  height: 0;
}

.video-js.vjs-16-9 {
  padding-top: 56.25%;
}

.video-js.vjs-4-3 {
  padding-top: 75%;
}

.video-js.vjs-fill {
  width: 100%;
  height: 100%;
}

.video-js .vjs-tech {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

body.vjs-full-window {
  padding: 0;
  margin: 0;
  height: 100%;
  overflow-y: auto;
}

.vjs-full-window .video-js.vjs-fullscreen {
  position: fixed;
  overflow: hidden;
  z-index: 1000;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.video-js.vjs-fullscreen {
  width: 100% !important;
  height: 100% !important;
  padding-top: 0 !important;
}

.video-js.vjs-fullscreen.vjs-user-inactive {
  cursor: none;
}

.vjs-hidden {
  display: none !important;
}

.video-js .vjs-offscreen {
  height: 1px;
  left: -9999px;
  position: absolute;
  top: 0;
  width: 1px;
}

.vjs-lock-showing {
  display: block !important;
  opacity: 1;
  visibility: visible;
}

.vjs-no-js {
  padding: 20px;
  color: #fff;
  background-color: #000;
  font-size: 18px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  width: 300px;
  height: 150px;
  margin: 0px auto;
}

.vjs-no-js a,
.vjs-no-js a:visited {
  color: #66a8cc;
}

.video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 1.5em;
  height: 1.5em;
  width: 3em;
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2b333f;
  background-color: rgba(43, 51, 63, 0.7);
  -webkit-border-radius: 0.3em;
  -moz-border-radius: 0.3em;
  border-radius: 0.3em;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
}

.vjs-big-play-centered .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.75em;
  margin-left: -1.5em;
}

.video-js:hover .vjs-big-play-button,
.video-js .vjs-big-play-button:focus {
  outline: 0;
  border-color: #fff;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  -webkit-transition: all 0s;
  -moz-transition: all 0s;
  -o-transition: all 0s;
  transition: all 0s;
}

.vjs-controls-disabled .vjs-big-play-button,
.vjs-has-started .vjs-big-play-button,
.vjs-using-native-controls .vjs-big-play-button,
.vjs-error .vjs-big-play-button {
  display: none;
}

.video-js button {
  background: none;
  border: none;
  color: inherit;
  display: inline-block;
  overflow: visible;
  font-size: inherit;
  line-height: inherit;
  text-transform: none;
  text-decoration: none;
  transition: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.video-js .vjs-control.vjs-close-button {
  cursor: pointer;
  height: 3em;
  position: absolute;
  right: 0;
  top: 0.5em;
  z-index: 2;
}

.vjs-menu-button {
  cursor: pointer;
}

.vjs-menu .vjs-menu-content {
  display: block;
  padding: 0;
  margin: 0;
  overflow: auto;
}

.vjs-scrubbing .vjs-menu-button:hover .vjs-menu {
  display: none;
}

.vjs-menu li {
  list-style: none;
  margin: 0;
  padding: 0.2em 0;
  line-height: 1.4em;
  font-size: 1.2em;
  text-align: center;
  text-transform: lowercase;
}

.vjs-menu li:focus,
.vjs-menu li:hover {
  outline: 0;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.vjs-menu li.vjs-selected,
.vjs-menu li.vjs-selected:focus,
.vjs-menu li.vjs-selected:hover {
  background-color: #fff;
  color: #2b333f;
}

.vjs-menu li.vjs-menu-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 1em;
  line-height: 2em;
  padding: 0;
  margin: 0 0 0.3em 0;
  font-weight: bold;
  cursor: default;
}

.vjs-menu-button-popup .vjs-menu {
  display: none;
  position: absolute;
  bottom: 0;
  width: 10em;
  left: -3em;
  height: 0em;
  margin-bottom: 1.5em;
  border-top-color: rgba(43, 51, 63, 0.7);
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  background-color: #2b333f;
  background-color: rgba(43, 51, 63, 0.7);
  position: absolute;
  width: 100%;
  bottom: 1.5em;
  max-height: 15em;
}

.vjs-menu-button-popup:hover .vjs-menu,
.vjs-menu-button-popup .vjs-menu.vjs-lock-showing {
  display: block;
}

.video-js .vjs-menu-button-inline {
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
  overflow: hidden;
}

.video-js .vjs-menu-button-inline:before {
  width: 2.222222222em;
}

.video-js .vjs-menu-button-inline:hover,
.video-js .vjs-menu-button-inline:focus,
.video-js .vjs-menu-button-inline.vjs-slider-active,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 12em;
}

.video-js .vjs-menu-button-inline.vjs-slider-active {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  transition: none;
}

.vjs-menu-button-inline .vjs-menu {
  opacity: 0;
  height: 100%;
  width: auto;
  position: absolute;
  left: 4em;
  top: 0;
  padding: 0;
  margin: 0;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
}

.vjs-menu-button-inline:hover .vjs-menu,
.vjs-menu-button-inline:focus .vjs-menu,
.vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  display: block;
  opacity: 1;
}

.vjs-no-flex .vjs-menu-button-inline .vjs-menu {
  display: block;
  opacity: 1;
  position: relative;
  width: auto;
}

.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu,
.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,
.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  width: auto;
}

.vjs-menu-button-inline .vjs-menu-content {
  width: auto;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.video-js .vjs-control-bar {
  display: none;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3em;
  background-color: #2b333f;
  background-color: rgba(43, 51, 63, 0.7);
}

.vjs-has-started .vjs-control-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  visibility: visible;
  opacity: 1;
  -webkit-transition: visibility 0.1s, opacity 0.1s;
  -moz-transition: visibility 0.1s, opacity 0.1s;
  -o-transition: visibility 0.1s, opacity 0.1s;
  transition: visibility 0.1s, opacity 0.1s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 1s, opacity 1s;
  -moz-transition: visibility 1s, opacity 1s;
  -o-transition: visibility 1s, opacity 1s;
  transition: visibility 1s, opacity 1s;
}

.vjs-controls-disabled .vjs-control-bar,
.vjs-using-native-controls .vjs-control-bar,
.vjs-error .vjs-control-bar {
  display: none !important;
}

.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1;
  visibility: visible;
}

@media �screen {
  .vjs-user-inactive.vjs-playing .vjs-control-bar :before {
    content: "";
  }
}

.vjs-has-started.vjs-no-flex .vjs-control-bar {
  display: table;
}

.video-js .vjs-control {
  outline: none;
  position: relative;
  text-align: center;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 4em;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}
.video-js .vjs-control:before {
  font-size: 1.8em;
  line-height: 1.67;
}

.video-js .vjs-control:focus:before,
.video-js .vjs-control:hover:before,
.video-js .vjs-control:focus {
  text-shadow: 0em 0em 1em white;
}

.video-js .vjs-control-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.vjs-no-flex .vjs-control {
  display: table-cell;
  vertical-align: middle;
}

.video-js .vjs-custom-control-spacer {
  display: none;
}

.video-js .vjs-progress-control {
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.vjs-live .vjs-progress-control {
  display: none;
}

.video-js .vjs-progress-holder {
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
  height: 0.3em;
}

.video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.666666666666666666em;
}

/* If we let the font size grow as much as everything else, the current time tooltip ends up
 ginormous. If you'd like to enable the current time tooltip all the time, this should be disabled
 to avoid a weird hitch when you roll off the hover. */
.video-js .vjs-progress-control:hover .vjs-mouse-display:after,
.video-js .vjs-progress-control:hover .vjs-play-progress:after {
  display: block;
  font-size: 0.6em;
}

.video-js .vjs-progress-holder .vjs-play-progress,
.video-js .vjs-progress-holder .vjs-load-progress,
.video-js .vjs-progress-holder .vjs-load-progress div {
  position: absolute;
  display: block;
  height: 0.3em;
  margin: 0;
  padding: 0;
  width: 0;
  left: 0;
  top: 0;
}

.video-js .vjs-mouse-display:before {
  display: none;
}

.video-js .vjs-play-progress {
  background-color: #fff;
}
.video-js .vjs-play-progress:before {
  position: absolute;
  top: -0.333333333333333em;
  right: -0.5em;
  font-size: 0.9em;
}

.video-js .vjs-mouse-display:after,
.video-js .vjs-play-progress:after {
  display: none;
  position: absolute;
  top: -2.4em;
  right: -1.5em;
  font-size: 0.9em;
  color: #000;
  content: attr(data-current-time);
  padding: 0.2em 0.5em;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.8);
  -webkit-border-radius: 0.3em;
  -moz-border-radius: 0.3em;
  border-radius: 0.3em;
}

.video-js .vjs-play-progress:before,
.video-js .vjs-play-progress:after {
  z-index: 1;
}

.video-js .vjs-load-progress {
  background: ligthen(#73859f, 25%);
  background: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-load-progress div {
  background: ligthen(#73859f, 50%);
  background: rgba(115, 133, 159, 0.75);
}

.video-js.vjs-no-flex .vjs-progress-control {
  width: auto;
}

.video-js .vjs-progress-control .vjs-mouse-display {
  display: none;
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #000;
  z-index: 1;
}

.vjs-no-flex .vjs-progress-control .vjs-mouse-display {
  z-index: 0;
}

.video-js .vjs-progress-control:hover .vjs-mouse-display {
  display: block;
}

.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display,
.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display:after {
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 1s, opacity 1s;
  -moz-transition: visibility 1s, opacity 1s;
  -o-transition: visibility 1s, opacity 1s;
  transition: visibility 1s, opacity 1s;
}

.video-js.vjs-user-inactive.vjs-no-flex
  .vjs-progress-control
  .vjs-mouse-display,
.video-js.vjs-user-inactive.vjs-no-flex
  .vjs-progress-control
  .vjs-mouse-display:after {
  display: none;
}

.video-js .vjs-progress-control .vjs-mouse-display:after {
  color: #fff;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.8);
}

.video-js .vjs-slider {
  outline: 0;
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0 0.45em 0 0.45em;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-slider:focus {
  text-shadow: 0em 0em 1em white;
  -webkit-box-shadow: 0 0 1em #fff;
  -moz-box-shadow: 0 0 1em #fff;
  box-shadow: 0 0 1em #fff;
}

.video-js .vjs-mute-control,
.video-js .vjs-volume-menu-button {
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}

.video-js .vjs-volume-control {
  width: 5em;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.video-js .vjs-volume-bar {
  margin: 1.35em 0.45em;
}

.vjs-volume-bar.vjs-slider-horizontal {
  width: 5em;
  height: 0.3em;
}

.vjs-volume-bar.vjs-slider-vertical {
  width: 0.3em;
  height: 5em;
  margin: 1.35em auto;
}

.video-js .vjs-volume-level {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
}
.video-js .vjs-volume-level:before {
  position: absolute;
  font-size: 0.9em;
}

.vjs-slider-vertical .vjs-volume-level {
  width: 0.3em;
}
.vjs-slider-vertical .vjs-volume-level:before {
  top: -0.5em;
  left: -0.3em;
}

.vjs-slider-horizontal .vjs-volume-level {
  height: 0.3em;
}
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.3em;
  right: -0.5em;
}

.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
  height: 100%;
}

.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {
  width: 100%;
}

.vjs-menu-button-popup.vjs-volume-menu-button .vjs-menu {
  display: block;
  width: 0;
  height: 0;
  border-top-color: transparent;
}

.vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {
  left: 0.5em;
  height: 8em;
}

.vjs-menu-button-popup.vjs-volume-menu-button-horizontal .vjs-menu {
  left: -2em;
}

.vjs-menu-button-popup.vjs-volume-menu-button .vjs-menu-content {
  height: 0;
  width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.vjs-volume-menu-button-vertical:hover .vjs-menu-content,
.vjs-volume-menu-button-vertical .vjs-lock-showing .vjs-menu-content {
  height: 8em;
  width: 2.9em;
}

.vjs-volume-menu-button-horizontal:hover .vjs-menu-content,
.vjs-volume-menu-button-horizontal .vjs-lock-showing .vjs-menu-content {
  height: 2.9em;
  width: 8em;
}

.vjs-volume-menu-button.vjs-menu-button-inline .vjs-menu-content {
  background-color: transparent !important;
}

.vjs-poster {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
}

.vjs-poster img {
  display: block;
  margin: 0 auto;
  max-height: 100%;
  padding: 0;
  width: 100%;
}

.vjs-has-started .vjs-poster {
  display: none;
}

.vjs-audio.vjs-has-started .vjs-poster {
  display: block;
}

.vjs-controls-disabled .vjs-poster {
  display: none;
}

.vjs-using-native-controls .vjs-poster {
  display: none;
}

.video-js .vjs-live-control {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
  font-size: 1em;
  line-height: 3em;
}

.vjs-no-flex .vjs-live-control {
  display: table-cell;
  width: auto;
  text-align: left;
}

.video-js .vjs-time-control {
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  font-size: 1em;
  line-height: 3em;
}

.vjs-live .vjs-time-control {
  display: none;
}

.video-js .vjs-current-time,
.vjs-no-flex .vjs-current-time {
  display: none;
}

.video-js .vjs-duration,
.vjs-no-flex .vjs-duration {
  display: none;
}

.vjs-time-divider {
  display: none;
  line-height: 3em;
}

.vjs-live .vjs-time-divider {
  display: none;
}

.video-js .vjs-play-control {
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}

.vjs-text-track-display {
  position: absolute;
  bottom: 3em;
  left: 0;
  right: 0;
  top: 0;
  pointer-events: none;
}

.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {
  bottom: 1em;
}

.video-js .vjs-text-track {
  font-size: 1.4em;
  text-align: center;
  margin-bottom: 0.1em;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.5);
}

.vjs-subtitles {
  color: #fff;
}

.vjs-captions {
  color: #fc6;
}

.vjs-tt-cue {
  display: block;
}

video::-webkit-media-text-track-display {
  -moz-transform: translateY(-3em);
  -ms-transform: translateY(-3em);
  -o-transform: translateY(-3em);
  -webkit-transform: translateY(-3em);
  transform: translateY(-3em);
}

.video-js.vjs-user-inactive.vjs-playing
  video::-webkit-media-text-track-display {
  -moz-transform: translateY(-1.5em);
  -ms-transform: translateY(-1.5em);
  -o-transform: translateY(-1.5em);
  -webkit-transform: translateY(-1.5em);
  transform: translateY(-1.5em);
}

.video-js .vjs-fullscreen-control {
  width: 3.8em;
  cursor: pointer;
  -webkit-box-flex: none;
  -moz-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
}

.vjs-playback-rate .vjs-playback-rate-value {
  font-size: 1.5em;
  line-height: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
}

.vjs-playback-rate .vjs-menu {
  width: 4em;
  left: 0em;
}

.vjs-error .vjs-error-display .vjs-modal-dialog-content {
  font-size: 1.4em;
  text-align: center;
}

.vjs-error .vjs-error-display:before {
  color: #fff;
  content: "X";
  font-family: Arial, Helvetica, sans-serif;
  font-size: 4em;
  left: 0;
  line-height: 1;
  margin-top: -0.5em;
  position: absolute;
  text-shadow: 0.05em 0.05em 0.1em #000;
  text-align: center;
  top: 50%;
  vertical-align: middle;
  width: 100%;
}

.vjs-loading-spinner {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  opacity: 0.85;
  text-align: left;
  border: 6px solid rgba(43, 51, 63, 0.7);
  box-sizing: border-box;
  background-clip: padding-box;
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

.vjs-seeking .vjs-loading-spinner,
.vjs-waiting .vjs-loading-spinner {
  display: block;
}

.vjs-loading-spinner:before,
.vjs-loading-spinner:after {
  content: "";
  position: absolute;
  margin: -6px;
  box-sizing: inherit;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  opacity: 1;
  border: inherit;
  border-color: transparent;
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:before,
.vjs-seeking .vjs-loading-spinner:after,
.vjs-waiting .vjs-loading-spinner:before,
.vjs-waiting .vjs-loading-spinner:after {
  -webkit-animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8)
      infinite,
    vjs-spinner-fade 1.1s linear infinite;
  animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
    vjs-spinner-fade 1.1s linear infinite;
}

.vjs-seeking .vjs-loading-spinner:before,
.vjs-waiting .vjs-loading-spinner:before {
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:after,
.vjs-waiting .vjs-loading-spinner:after {
  border-top-color: white;
  -webkit-animation-delay: 0.44s;
  animation-delay: 0.44s;
}

@keyframes vjs-spinner-spin {
  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes vjs-spinner-spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}

@-webkit-keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}

.vjs-chapters-button .vjs-menu {
  left: -10em;
  width: 0;
}

.vjs-chapters-button .vjs-menu ul {
  width: 24em;
}

.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-custom-control-spacer {
  -webkit-box-flex: auto;
  -moz-box-flex: auto;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
}

.video-js.vjs-layout-tiny:not(.vjs-fullscreen).vjs-no-flex
  .vjs-custom-control-spacer {
  width: auto;
}

.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-current-time,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-time-divider,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-progress-control,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-duration,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-remaining-time,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-playback-rate,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-mute-control,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-control,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-chapters-button,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subtitles-button,
.video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-menu-button {
  display: none;
}

.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-current-time,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-time-divider,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-duration,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-remaining-time,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-playback-rate,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-mute-control,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-control,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-chapters-button,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subtitles-button,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-button,
.video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-fullscreen-control {
  display: none;
}

.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-current-time,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-captions-button,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-time-divider,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-duration,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-remaining-time,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-playback-rate,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-mute-control,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-control,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-chapters-button,
.video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-subtitles-button {
  display: none;
}

.vjs-caption-settings {
  position: relative;
  top: 1em;
  background-color: #2b333f;
  background-color: rgba(43, 51, 63, 0.75);
  color: #fff;
  margin: 0 auto;
  padding: 0.5em;
  height: 15em;
  font-size: 12px;
  width: 40em;
}

.vjs-caption-settings .vjs-tracksettings {
  top: 0;
  bottom: 2em;
  left: 0;
  right: 0;
  position: absolute;
  overflow: auto;
}

.vjs-caption-settings .vjs-tracksettings-colors,
.vjs-caption-settings .vjs-tracksettings-font {
  float: left;
}

.vjs-caption-settings .vjs-tracksettings-colors:after,
.vjs-caption-settings .vjs-tracksettings-font:after,
.vjs-caption-settings .vjs-tracksettings-controls:after {
  clear: both;
}

.vjs-caption-settings .vjs-tracksettings-controls {
  position: absolute;
  bottom: 1em;
  right: 1em;
}

.vjs-caption-settings .vjs-tracksetting {
  margin: 5px;
  padding: 3px;
  min-height: 40px;
}

.vjs-caption-settings .vjs-tracksetting label {
  display: block;
  width: 100px;
  margin-bottom: 5px;
}

.vjs-caption-settings .vjs-tracksetting span {
  display: inline;
  margin-left: 5px;
}

.vjs-caption-settings .vjs-tracksetting > div {
  margin-bottom: 5px;
  min-height: 20px;
}

.vjs-caption-settings .vjs-tracksetting > div:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  min-height: 0;
}

.vjs-caption-settings label > input {
  margin-right: 10px;
}

.vjs-caption-settings input[type="button"] {
  width: 40px;
  height: 40px;
}

.video-js .vjs-modal-dialog {
  background: rgba(0, 0, 0, 0.8);
  background: -webkit-linear-gradient(
    -90deg,
    rgba(0, 0, 0, 0.8),
    rgba(255, 255, 255, 0)
  );
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.8),
    rgba(255, 255, 255, 0)
  );
}

.vjs-modal-dialog .vjs-modal-dialog-content {
  font-size: 1.2em;
  line-height: 1.5;
  padding: 20px 24px;
  z-index: 1;
}

.video-js {
  font-size: 10px;
  color: #fff;
  width: 100% !important;
  height: 100% !important;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.vjs-default-skin .vjs-big-play-button {
  /* video poster image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAC8UlEQVR42u2cMWgUQRSGU1hYWFgYCOrMbrCxFGysRBBsrMTS4mYmIUgsrARLrVKIlYKFha1gJZYWWoiCjUQQMSiBJBgTo8nubHIxkpxvzksuhf08ue+Dx179Pv6bndm3OzQEAAAAAAAAAAAAAAAAAAAAAP+mnjh6hC5oEuLsSgzFZTqhRYi3nTqYGJ19vOrKw3REgxCp6G07paVp2fN0RYGQvXJ2Q+Q8XJ4cPkR3NAhJaXG2LVKWKleeoUMKhOyrdgzmfseVB+mUDiGpNitvvzSuPEW3dAjZS4usL1OdW0MH6JoOIX/vxLz9WLvyJJ1TIGR/WtacvUn39Ajpri21N+9lM1nSRR1C9tJSjRWTdFKPkFS/pF5vjB87Tkd1COmW3B6vV6G4QleVCOnVVu2Llxzr6xGyW1Udikt0WI+QtG+RtNinHFQqEdKrbam1pjV6gW7rELJbv9NDMA4q9QhJtSP1I7ZGz9J5HUI6vUfGKS0POKjUIqSflsX1cXsaCzqE9PctobhLWvQIkTI7MZj5tQlzAiEqhPTvxJpQTiFEUwWzXXk70746UiJEWVrqQXwIplhIWlu2ZcGfbiaHRxCi5y/suyRlYWBOjxXLmJe15J2k5M1ADVXoTIV9leaMK2evD9z+RJmMxe6YkTcvBnZ4QpGMt713Va6xD8lY0RffUipkvXjOSFFmIdHJoi2pkN8tDrHyCllJA9xyfcboUGYh0dsP6SEVqcgupFiV64LUk8aVI3Q+p5BgPsl1ibd9swvpp4LBufxCZqM3c6Qiv5DYOxB8xHvv+YXMioiv1Vhxkc5mFFJ5Qyq0CJHd9lwaUIiuPEc38wppy257VRbuewxT5xbi7GIMllTkFtJ7LbqqvblDKrILMcty/cz3T3ILCcXWbip4lSC3kNA9lZ0hFfmFbMnC3ciacZsh6NxCnP2ZHqny9Z/sQgpSoUVIlT6CGcw0X/nRIWRT7qRukAotQkgFAAAAAAAAAAAAAAAAAAAAwP/NH0w6zE+Gk/OsAAAAAElFTkSuQmCC") !important;
  border: none !important;
  border-radius: 0 !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-color: rgba(0, 0, 0, 0.64);
}

span.vjs-icon-placeholder {
  visibility: hidden !important;
}

.vjs-default-skin .vjs-big-play-button:hover {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.vjs-default-skin .vjs-big-play-button:focus {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.vjs-default-skin .vjs-big-play-button:before {
  content: none !important;
}
/* The default color of control backgrounds is mostly black but with a little
   bit of blue so it can still be seen on all-black video frames, which are common. */
.video-js .vjs-control-bar,
.video-js .vjs-big-play-button,
.video-js .vjs-menu-button .vjs-menu-content {
  /* IE8 - has no alpha support */
  background-color: #000;
  /* Opacity: 1.0 = 100%, 0.0 = 0% */
  background-color: rgba(0, 0, 0, 0.38);
}

.video-js .vjs-slider {
  background-color: lighten(#333, 33%);
  background-color: rgba(lighten(#333, 33%), 0.5);
}

.video-js .vjs-volume-level,
.video-js .vjs-play-progress,
.video-js .vjs-slider-bar {
  background: #fff;
}

.video-js .vjs-load-progress {
  background: lighten(lighten(#333, 33%), 25%);
  background: rgba(lighten(#333, 33%), 0.5);
}

.video-js .vjs-load-progress div {
  background: lighten(lighten(#333, 33%), 50%);
  background: rgba(lighten(#333, 33%), 0.75);
}

.back-10s-btn, .skip-10s-btn {
  cursor: pointer;
  margin-right: 10px;
}

.back-10s-btn .back-ten-seconds, .skip-10s-btn .skip-ten-seconds {
  width: 20px;
  height: 20px;
}

#open-iv-btn {
  cursor: pointer;
  margin-right: 10px;
}

#open-iv-btn .iv-icon {
  width: 30px;
  height: 30px;
}

#background-before-video {
  width: 100%;
  height: 100%;
  background-color: #333;
  position: relative;
}

#background-before-video #loading-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#background-before-video .loader {
  margin-bottom: 20px;
}

#background-before-video .video-not-found {
  font-family: "Lato";
  color: rgba(241, 90, 36, 0.7);
}

#background-before-video .linkedin-btn {
  margin-bottom: 10px;
}

.videoWrapper {
  overflow: hidden;
}

#email-panel {
  color: rgba(255, 255, 255, 0.1);
  position: absolute;
  z-index: 1000;
  font-family: "Lato";
  font-size: 14px;
  pointer-events: none;
}

#block-panel {
  position: absolute;
  background-color: #333;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.transcript-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.transcript-link:hover {
  text-decoration: underline;
}

.vjs-mouse-display {
  font-family: "Lato";
}

.video-js .vjs-mouse-display:after,
.video-js .vjs-play-progress:after {
  top: -3.2em;
  font-family: "Lato";
}

.video-js .vjs-control-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 992px) {
  .video-js .vjs-control-bar {
    display: none;
  }
}

/* markers */

.vjs-marker span {
  font-size: 14px;
}

.vjs-marker {
  z-index: 1000 !important;
  font-family: "Lato";
}

.vjs-tip {
  bottom: 55px !important;
  z-index: 2000000 !important;
  /*max-width: 100% !important;*/
}

.vjs-tip .vjs-tip-inner {
  font-size: 16px;
  font-family: "Lato";
  /*max-width: 100% !important;*/
}

/*  @media screen and (min-width: 640px) {
    .vjs-marker {
        width: 20px !important;
    }

    #main_video {
        width: 640px !important;
        height: 400px !important;
    }
} */

.vjs-marker {
  color: white;
  border-color: black;
  top: 0px;
  padding: 7px 0px 0px 0px;
  position: absolute;
  left: 0;
  bottom: 0em;
  opacity: 1;
  height: 100%;
  transition: opacity 0.2s ease;
  -webkit-transition: opacity 0.2s ease;
  -moz-transition: opacity 0.2s ease;
}

.vjs-tip {
  visibility: hidden;
  display: block;
  opacity: 0.8;
  padding: 5px;
  font-size: 10px;
  position: absolute;
  bottom: 14px;
  z-index: 100000;
}
.vjs-tip .vjs-tip-arrow {
  background: url(data:image/gif;base64,R0lGODlhCQAJAIABAAAAAAAAACH5BAEAAAEALAAAAAAJAAkAAAIRjAOnwIrcDJxvwkplPtchVQAAOw==)
    no-repeat top left;
  bottom: 0;
  left: 50%;
  margin-left: -4px;
  background-position: bottom left;
  position: absolute;
  width: 9px;
  height: 5px;
}
.vjs-tip .vjs-tip-inner {
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  padding: 5px 8px 4px 8px;
  background-color: black;
  color: white;
  max-width: 200px;
  text-align: center;
}
.vjs-break-overlay {
  visibility: hidden;
  position: absolute;
  z-index: 100000;
  top: 0;
}
.vjs-break-overlay .vjs-break-overlay-text {
  padding: 9px;
  text-align: center;
}

/* spinner */

.video-js .vjs-loading-spinner {
  border-top-color: #79a9ad;
}

.video-js .vjs-loading-spinner:before,
.video-js .vjs-loading-spinner:after {
  border-top-color: #79a9ad;
}

.video-js .vjs-seeking .vjs-loading-spinner:before,
.video-js .vjs-waiting .vjs-loading-spinner:before {
  border-top-color: #79a9ad;
}

.video-js .vjs-seeking .vjs-loading-spinner:after,
.video-js .vjs-waiting .vjs-loading-spinner:after {
  border-top-color: #79a9ad;
}
.theme-title {
  font-weight: bold;
  color: #e96724;
  margin-bottom: 5px;
}

.theme-description {
  margin-bottom: 15px;
}

.interview-summary-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #e4e5e5;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.summary-header {
  font-weight: bold;
  margin-bottom: 15px;
  text-transform: uppercase;
}
@keyframes vjs-spinner-fade {
  0% {
    border-top-color: #79a9ad;
  }
  20% {
    border-top-color: #79a9ad;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #79a9ad;
  }
  100% {
    border-top-color: #79a9ad;
  }
}

@-webkit-keyframes vjs-spinner-fade {
  0% {
    border-top-color: #79a9ad;
  }
  20% {
    border-top-color: #79a9ad;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #79a9ad;
  }
  100% {
    border-top-color: #79a9ad;
  }
}

/* Glimpse Tab Styles */
.glimpse-tabs-container {
  position: absolute;
  top: -42px;
  left: 20px;
  z-index: 10;
  width: auto;
}

.glimpse-tabs {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: flex-start;
  gap: 5px;
}

.glimpse-tabs li {
  background-color: rgba(255, 255, 255, 0.8);
  border: 2px solid #e96724;
  border-bottom: none;
  border-radius: 15px 15px 0 0;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 600;
  color: #e96724;
  transition: all 0.3s ease;
  position: relative;
}

.glimpse-tabs li:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

.glimpse-tabs li.active {
  background-color: white;
  border-color: #e96724;
  color: #e96724;
  z-index: 11;
}

.glimpse-tabs li.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: white;
  z-index: 12;
}

@media (max-width: 768px) {
  .glimpse-tabs-container {
    left: 10px;
    top: -40px;
  }
  
  .glimpse-tabs {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  
  .glimpse-tabs li {
    margin: 5px 5px 5px 0;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
  }
}
</style>